import React, { useCallback, useState, useEffect, useRef, createRef, useMemo } from 'react';
import {
   useColorModeValue,
   Card,
   Grid,
   GridItem,
   Button,
   CardBody,
   CardHeader,
   Heading,
   useToast,
   CardFooter,
   Flex,
   useDisclosure,
   Box,
   Table,
   Thead,
   Tbody,
   Tr,
   Th,
   Td,
   TableContainer,
   IconButton,
   Image,
   Text,
   Badge,
   Icon,
   Modal,
   ModalBody,
   ModalCloseButton,
   ModalHeader,
   ModalContent,
   ModalOverlay,
} from '@chakra-ui/react';
import * as Yup from 'yup';
import moment from 'moment';
import Swal from 'sweetalert2';
import _ from 'lodash';

// UI
// import LineItem from '../../../sales/Pages/SalesInvoiceMaster/LineItem';
import LineItem from 'components/LineItem';
import BillTerm from '../../../sales/Pages/SalesInvoiceMaster/BillTerm';
import TaxableAmount from '../../../sales/Pages/SalesInvoiceMaster/TaxableAmount';
import { renderDynamicDropdown } from 'components/UIcomponents/DynamicDropdown';
import { renderDynamicDropdown as dynamicDropdown } from 'components/ui/DynamicDropdown';
import AccountSelect from 'components/AccountSelect/AccountSelect';
import InputField from 'components/ui/InputField';
import SerialNumberModal from '../../../sales/Pages/SalesInvoiceMaster/SerialNumberModal';
import CustomerVerifyModal from '../../../purchase/Pages/PurchaseInvoiceMaster/CustomerVerifyModal';
import TextareaField from 'components/ui/TextareaField';
import PrintFormat from 'components/PrintFormate/PrintFormat';
import TakaForm from '../../../purchase/Pages/PurchaseInvoiceMaster/TakaForm';
import MultiSelectDropdown from "components/ui/MultiSelectDropdown"

import { useParams, useNavigate } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';

// contexts
import { useUser, useGlobal, useBusinessType, useAccount, useDaybook, useItem } from '../../../../../contexts';

// hooks
import useCalculateTaxAmount from 'hooks/useSalesTaxAmount';
import useIssueLastDaybook from 'hooks/useIssueLastDaybook';

// Actions
import { getStock } from '../../../../../redux/actions/salesLineDetail';
import { getAccount } from '../../../../../redux/actions/account';
import { getPaymentDaybook, getDaybookById, getDaybook, updateDaybook } from '../../../../../redux/actions/daybook';
import { getItem } from '../../../../../redux/actions/item';
import { getMainAndSubHsn } from '../../../../../redux/actions/mainAndSubHsn';
import { getWarehouse } from '../../../../../redux/actions/warehouse';
import { getGLGroupsAllDropdown } from '../../../../../redux/actions/glGroup';
import { deleteSalesLineItem } from '../../../../../redux/actions/salesLineItem';
import { getBillTerm } from '../../../../../redux/actions/billTerm';
import { getSerialWiseHistory } from '../../../../../redux/actions/salesLineDetail';
import {
   getIssueInventories,
   getIssueInventory,
   emptyIssueInventory,
   addIssueInventory,
   updateIssueInventory,
   getPrevAndNext,
   checkDocNo,
   getLastIssueDaybook,
} from '../../../../../redux/actions/issueInventory';
import { getSetupFormat, setupFormatCustomQuery } from '../../../../../redux/actions/setupFormat';
import { getUsers } from '../../../../../redux/actions/user';
import { getGrayPurchasePendingIssue } from '../../../../../redux/actions/purchaseInvoice';
import { getFinancialYears } from '../../../../../redux/actions/dashboard';

// utils
import {
   removeDuplicates,
   getAccountAddress,
   getGstTaxType,
   getGstSubTaxType,
   handlePrintClick,
   injectDataIntoHtml,
   getFirstErrorMessage,
   formatAmount,
   getUniqueByStock,
   mergeRecords,
   setLineItemData
} from 'utils/util';
import { SupplyTypes } from 'utils/dropdownEnum';

// icons
import { FaTrash, FaHistory } from 'react-icons/fa';
import { FaCircleInfo } from 'react-icons/fa6';

// image
import phone from 'assets/img/nfts/phone.svg';
import Email from 'assets/img/nfts/email.svg';
import map from 'assets/img/nfts/map.svg';
import panno from 'assets/img/nfts/panno.svg';
import gstno from 'assets/img/nfts/gstno.svg';
import Brokername from 'assets/img/nfts/Brokername.svg';
import Balance from 'assets/img/nfts/Balance.svg';
import back from 'assets/img/nfts/back.svg';
import loaderAnimation from '../../../../../assets/img/auth/loding.gif';

import DeleteDialog from '../../../masters/components/DeleteDialog';
import SelectTakaDetail from './SelectTakaDetail';

// import { USER_TYPES } from 'constants';

const validationSchema = Yup.object().shape({
   header: Yup.object().shape({
      daybookId: Yup.number()
         .typeError('Daybook is required')
         .required('Daybook is required')
         .positive('Invalid daybook selected'),

      docno: Yup.string().required('Document number is required').trim(),

      transactionAt: Yup.date()
         .required('Transaction date is required'),

      accountId: Yup.number()
         .typeError('Account is required')
         .required('Account is required')
         .positive('Invalid account selected'),

      basicAmount: Yup.number().required('Basic amount is required').min(0, 'Basic amount cannot be negative'),
      // .test(
      //    'is-decimal',
      //    'Amount cannot have more than 2 decimal places',
      //    (value) => !value || Number.isInteger(value * 100),
      // ),
      netAmount: Yup.number().required('Net amount is required'),
   }),

   lineItem: Yup.array()
      .required('Line items are required')
      .min(1, 'At least one line item is required')
      .of(
         Yup.object().shape({
            itemId: Yup.number()
               .typeError('Item is required')
               .required('Item is required')
               .positive('Invalid item selected'),
            itemRate: Yup.number().required('Item rate is required').min(0, 'Item rate cannot be negative'),
            // .test(
            //    'is-decimal',
            //    'Rate cannot have more than 2 decimal places',
            //    (value) => !value || Number.isInteger(value * 100),
            // ),

            qty1: Yup.number().required('Quantity is required').min(0, 'Quantity cannot be negative'),

            qty2: Yup.number().default(0).min(0, 'Quantity cannot be negative').optional(),

            qty3: Yup.number().default(0).min(0, 'Quantity cannot be negative').optional(),

            amount: Yup.number().required('Amount is required').min(0, 'Amount cannot be negative'),

            ratePer: Yup.number().min(0, 'Rate per cannot be negative'),

            uomNoForRate: Yup.number()
               .integer('UOM number must be a whole number')
               .min(0, 'UOM number cannot be negative'),

            // salesprice2: Yup.number().default(0).min(0, 'Sales price cannot be negative'),

            // salesprice3: Yup.number().default(0).min(0, 'Sales price cannot be negative'),

            lineNumber: Yup.number()
               .required('Line number is required')
               .positive('Line number must be positive')
               .integer('Line number must be a whole number'),
         }),
      ),
});

const invoiceType = 'issue';

const IssueForm = () => {
   const { isOpen: isOpenModal, onOpen: onOpenModal, onClose: onCloseModal } = useDisclosure();
   const {
      isOpen: isOpenTakaDetailModal,
      onOpen: onOpenTakaDetailModal,
      onClose: onCloseTakaDetailModal,
   } = useDisclosure();
   const { isOpen: isOpenVerifyModal, onOpen: onOpenVerifyModal, onClose: onCloseVerifyModal } = useDisclosure();
   const { isOpen: isOpenDeleteModal, onOpen: onOpenDeleteModal, onClose: onCloseDeleteModal } = useDisclosure();
   const { isOpen: isOpenSerialhistory, onOpen: onOpenSerialhistory, onClose: onCloseSerialhistory } = useDisclosure();
   const { isOpen: isOpenAdjustedDocs, onOpen: onOpenAdjustedDocs, onClose: onCloseAdjustedDocs } = useDisclosure();
   const {
      isOpen: isOpenPrintFormatModal,
      onOpen: onOpenPrintFormatModal,
      onClose: onClosePrintFormatModal,
   } = useDisclosure();
   const { lastDaybook, setSelectedDaybookId: setDaybookId } = useIssueLastDaybook();
   const { isOpen: isOpenTakaModal, onOpen: onOpenTakaModal, onClose: onCloseTakaModal } = useDisclosure();
   const { user } = useUser();
   const { companyList, company } = useGlobal();
   const { businessTypes } = useBusinessType();
   const { items: itemData } = useItem();
   const { accounts: accountData } = useAccount();
   const { issueDaybooks: daybookData } = useDaybook();
   const [selectedDaybookData, setSelectedDaybookData] = useState(null);
   const [originalPrefix, setOriginalPrefix] = useState('');
   const [originalPostFix, setOriginalPostFix] = useState('');
   // all Selector
   // const itemData = useSelector((state) => state.item?.list);
   // const daybookData = useSelector((state) => state.daybook?.allDaybooks || []);
   // const accountData = useSelector((state) => state?.account?.list);
   const billTermData = useSelector((state) => state.billTerm?.list);
   const salesInvoice = useSelector((state) => state.issueInventory?.single);
   const stocks = useSelector((state) => state?.salesLineDetail?.stocks);
   const warehouse = useSelector((state) => state?.warehouse?.list);
   const selectedDaybook = useSelector((state) => state.daybook.single);
   const warehouseList = useSelector((state) => state.warehouse.list);
   // const companyData = useSelector((state) => state.company.single);
   const companyData = company;
   const glGroup = useSelector((state) => state.glGroup?.ledger || []);
   const targetGlGroup = glGroup?.find((group) => group.code === 'E');
   const serialWiseHistory = useSelector((state) => state?.salesLineDetail?.serialhistory);
   const adjustedDocs = useSelector((state) => state?.sales?.adjusted);
   const [data, setData] = useState([]);
   const [shouldFetch, setShouldFetch] = useState(false);
   const [selectedItem, setSelectedItem] = useState(null);
   const transportList = useSelector((state) => state.transport?.list);
   const vehicleList = useSelector((state) => state.vehicle?.list);
   const prints = useSelector((state) => state.setupPrint.list);
   const salesManList = useSelector((state) => state.users.users || []);
   const purchase = useSelector((state) => state.purchaseInvoice.grayPurchasePendingIssue ?? []);
   const financialYears = useSelector((state) => state?.dashboard?.financialYears);
   const { userGlobalSettingsData } = useGlobal();
   const [filedDisabled, setFiledDisabled] = useState(false);
   const shouldSendCompanyIdDaybook = userGlobalSettingsData?.[0]?.askCompany?.daybook || false;
   const shouldSendCompanyIdAccount = userGlobalSettingsData?.[0]?.askCompany?.account || false;
   const shouldSendCompanyIdItem = userGlobalSettingsData?.[0]?.askCompany?.item || false;
   const shouldSendCompanyIdWarehouse = userGlobalSettingsData?.[0]?.askCompany?.warehouse || false;
   const shouldSendCompanyidBillTerm = userGlobalSettingsData?.[0]?.askCompany?.bllTerm || false;

   const initialLineItem = useMemo(() => {
      return {
         typeOfSupply: 1,
         headerId: 1,
         gst: 0,
         netGst: 0,
         gstAmount: 0,
         itemId: null,
         lineNumber: 1,
         itemRate: null,
         amount: 0,
         netAmount: 0,
         taxableAmount: 0,
         ratePer: 0,
         uomNoForRate: 0,
         salesprice1: 0,
         salesprice2: 0,
         salesprice3: 0,
         qty1: 0,
         qty2: 0,
         qty3: 0,
         hsnData: company?.hsndata,
         sacData: company?.sacdata,
         ratio: null,
         addLess1Percent: 0,
         addLess1Amount: 0,
         addLess2Percent: 0,
         addLess2Amount: 0,
         addLess3Percent: 0,
         addLess3Amount: 0,
         stock: [],
         unit: null,
         qUnitId1: null,
         qUnitId2: null,
         qUnitId3: null,
         warehouseId: null,
         // purchaseDocumentId: null,
         isDeleted: false,
         notes: '',
         remarks: '',
         gstWithRate: null,
         pliId: null,
         pcliId: null,
         lotNumber: null,
         itemScreenId: null,
      };
   }, [company?.hsndata, company?.sacdata]);

   const [errors, setErrors] = useState({});
   const [billTerms, setBillTerms] = useState([]);
   const [stockList, setStockList] = useState([]);
   const [selectedStocks, setSelectedStocks] = useState([]);
   const [deleteLineItemId, setDeleteLineItemId] = useState(null);
   const [isSameState, setIsSameState] = useState(null);
   const [voucher, setVoucher] = useState(null);
   const [isLoading, setIsLoading] = useState(false);
   const [currentLineItemIdx, setCurrentLineItemIdx] = useState(null);
   const [isPageLoading, setIsPageLoading] = useState(true);
   const [purchaseDocIds, setPurchaseDocIds] = useState([]);
   const [takaDetails, setTakaDetails] = useState([]);
   const [currentTakaDetails, setCurrentTakaDetails] = useState([]);
   const [purchaseDoc, setPurchaseDoc] = useState([]);

   const [row, setRow] = useState({
      header: {
         daybookId: lastDaybook?.daybookId || '',
         docno: '',
         transactionAt: new Date().toISOString().split('T')[0],
         prefix: '',
         postFix: '',
         companyId: '',
         accountId: '',
         brokerId: '',
         basicAmount: 0,
         additionAmount: '',
         deductionAmount: '',
         netAmount: 0,
         dueDays: 0,
         dueAt: new Date().toISOString().split('T')[0],
         billtoStateId: null,
         shiptoStateId: null,
         warehouseId: null,
         notes: '',
         vehicleId: null,
         transportId: null,
         representativeId: user?.id,
      },
      lineItem: [initialLineItem],
   });

   const { id } = useParams();
   const toast = useToast();
   const dispatch = useDispatch();
   const textColor = useColorModeValue('gray.800', 'white');
   const navigate = useNavigate();

   const {
      totals,
      handleQtyChange,
      handleRateChange,
      handleDiscountChange,
      setTotalBillTermAmount,
      setBillTerm,
      finalNetAmount,
      handleItemChange,
      handleUnitChange,
   } = useCalculateTaxAmount({
      row,
      setRow,
      setBillTerms,
      invoiceType,
   });

   // get value in local storage
   const accountId = localStorage.getItem('accountId');
   const daybookId = localStorage.getItem('daybook');

   const lastClick = useRef(0);

   // Create refs for each input field
   const daybookRef = useRef(null);
   const docNoRef = useRef(null);
   const transactionAtRef = useRef(null);
   const accountRef = useRef(null);
   const brokerRef = useRef(null);
   const dueDaysRef = useRef(null);
   const dueDateRef = useRef(null);
   const transportRef = useRef(null);
   const submitRef = useRef(null);
   const closeRef = useRef(null);
   const vehicleRef = useRef(null);
   const notesRef = useRef(null);
   const supplierRef = useRef(null);
   const wareHouseRef = useRef(null);
   const lineItemNotesRef = useRef(null);
   const lineItemRemarkRef = useRef(null);
   const purchaseDocRef = useRef(null);
   const warehouseRef = useRef([]);
   const itemRefs = useRef([]);
   const qty1Refs = useRef([]);
   const qty2Ref = useRef([]);
   const qty3Ref = useRef([]);
   const rateRefs = useRef([]);
   const gstRateRefs = useRef([]);
   const gstTaxableRefs = useRef([]);
   const percentageRefs = useRef([]);
   const amountRefs = useRef([]);
   const subamountRefs = useRef([]);
   const purchaseDocumentRef = useRef([]);
   const itemScreenIdRefs = useRef([]);
   const lotNumberRefs = useRef([]);
   // const paymentRefs = useRef([]);
   const refs = {
      itemRefs,
      qty1Refs,
      qty2Ref,
      qty3Ref,
      warehouseRef,
      rateRefs,
      percentageRefs,
      subamountRefs,
      amountRefs,
      dueDaysRef,
      purchaseDocumentRef,
      lineItemNotesRef,
      lineItemRemarkRef,
      gstRateRefs,
      gstTaxableRefs,
      itemScreenIdRefs,
      lotNumberRefs,
   };

   const daybook = useMemo(() => {
      return daybookData?.filter((item) => item.type === 19).find((daybook) => daybook.id === row.header.daybookId);
   }, [daybookData, row.header.daybookId]);

   const pendingPayment = useMemo(() => {
      let badgeColor = 'blue.400';
      let borderColor = 'blue.400';

      if (id && salesInvoice?.pendingstatus === 'FULL PENDING') {
         badgeColor = 'orange.400';
         borderColor = 'orange.400';
      } else if (id && salesInvoice?.pendingstatus === 'CLEAR') {
         badgeColor = 'green.400';
         borderColor = 'green.400';
      } else if (id && salesInvoice?.pendingstatus === 'PART PENDING') {
         badgeColor = 'blue.400';
         borderColor = 'blue.400';
      }

      return { badgeColor, borderColor };
   }, [id, salesInvoice?.pendingstatus]);

   const account = useMemo(() => {
      return accountData.find((account) => account.id === row.header.accountId);
   }, [accountData, row.header.accountId]);

   const handleKeyDown = (e, nextRef, preRef) => {
      // if (e.key === 'Enter' || e.key === 'Tab') {
      //    e.preventDefault();
      //    if (nextRef && nextRef?.current) {
      //       nextRef?.current?.focus();
      //    }
      // }
      if (e.key === 'Enter' || (e.key === 'Tab' && !e.shiftKey)) {
         e.preventDefault();
         if (nextRef && nextRef?.current) {
            nextRef?.current?.focus();
         }
      }
      if (e.key === 'Tab' && e.shiftKey) {
         e.preventDefault();
         if (preRef && preRef?.current) {
            preRef?.current?.focus();
         }
      }
   };

   const prepareRowRefs = (count) => {
      warehouseRef.current = Array(count)
         .fill()
         .map((_, i) => warehouseRef.current[i] || createRef());

      itemRefs.current = Array(count)
         .fill()
         .map((_, i) => itemRefs.current[i] || createRef());

      qty1Refs.current = Array(count)
         .fill()
         .map((_, i) => qty1Refs.current[i] || createRef());

      rateRefs.current = Array(count)
         .fill()
         .map((_, i) => rateRefs.current[i] || createRef());

      gstRateRefs.current = Array(count)
         .fill()
         .map((_, i) => gstRateRefs.current[i] || createRef());

      gstTaxableRefs.current = Array(count)
         .fill()
         .map((_, i) => gstTaxableRefs.current[i] || createRef());
      lineItemNotesRef.current = Array(count)
         ?.fill()
         ?.map((_, i) => lineItemNotesRef?.current?.[i] || createRef());

      lineItemRemarkRef.current = Array(count)
         ?.fill()
         ?.map((_, i) => lineItemRemarkRef?.current?.[i] || createRef());
      purchaseDocumentRef.current = Array(count)
         ?.fill()
         ?.map((_, i) => purchaseDocumentRef?.current?.[i] || createRef());

      itemScreenIdRefs.current = Array(count)
         ?.fill()
         ?.map((_, i) => itemScreenIdRefs?.current?.[i] || createRef());

      lotNumberRefs.current = Array(count)
         ?.fill()
         ?.map((_, i) => lotNumberRefs?.current?.[i] || createRef());
   };

   const prepareBillTermRowRefs = (count) => {
      percentageRefs.current = Array(count)
         .fill()
         .map((_, i) => percentageRefs.current[i] || createRef());

      amountRefs.current = Array(count)
         .fill()
         .map((_, i) => amountRefs.current[i] || createRef());
   };

   const validateForm = useCallback(async () => {
      try {
         await validationSchema.validate(row, { abortEarly: false });
         setErrors({});
         return true;
      } catch (error) {
         if (error instanceof Yup.ValidationError) {
            const newErrors = {};
            error.inner.forEach((err) => {
               newErrors[err.path] = err.message;
            });
            console.log("errors", error, newErrors);
            setErrors(newErrors);
            return false;
         }
         return false;
      }
   }, [row]);

   const handleStockModalOnClick = useCallback(
      async (index) => {
         const itemData = row.lineItem[Number(index)];
         if (businessTypes?.businessType?.toUpperCase() === 'MOBILE') {
            if (user?.loginhistory?.companyId)
               await dispatch(
                  getStock({
                     itemId: Number(itemData?.itemId),
                     companyId: Number(user?.loginhistory?.companyId),
                     type: 'issue',
                  }),
               );
            setStockList((prev) => getUniqueByStock(prev.concat(itemData?.stock)));
            onOpenModal();
         }

         if (
            daybook &&
            daybook.getLineDetail &&
            itemData.itemId &&
            itemData.itemId > 0 &&
            businessTypes?.businessType?.toUpperCase() === 'TEXTILE'
         ) {
            setCurrentLineItemIdx(index);
            setCurrentTakaDetails(row.lineItem[index]?.takaDetails || []);
            if (daybook?.getLineDetail && daybook?.isMillIssue && (itemData?.pcliId || itemData?.pliId)) {
               if (Array.isArray(itemData.takaDetails) && Array.from(itemData?.takaDetails).length > 0) {
                  setTakaDetails(itemData.takaDetails.map((i) => ({ ...i, isSelected: true, id: i.id })));
                  onOpenTakaDetailModal();
               } else {
                  onOpenTakaModal();
               }
            } else {
               setCurrentTakaDetails(row.lineItem[index]?.takaDetails || []);
               onOpenTakaModal();
            }
         }
      },
      [
         businessTypes?.businessType,
         daybook,
         dispatch,
         onOpenModal,
         onOpenTakaDetailModal,
         onOpenTakaModal,
         purchase,
         row.lineItem,
         user?.loginhistory?.companyId,
      ],
   );

   const handleDaybook = async (name, value) => {
      const newRow = { ...row };

      setDaybookId(Number(value));

      await dispatch(
         getBillTerm({
            daybookId: Number(value),
            ...(shouldSendCompanyidBillTerm && { companyIds: user?.loginhistory?.companyId }),
         }),
      );

      newRow.header[name] = value;
      setRow(newRow);
      setErrors((prev) => {
         const obj = prev;
         const fullName = `header.${name}`;
         delete obj[fullName];
         return obj;
      });
   };

   const handleAccount = useCallback(
      async (name, value) => {
         if (name === 'accountId') {
            const newRow = { ...row };
            const id = typeof value === 'object' && value !== null ? value.id : value;

            newRow.header[name] = id;
            setRow(newRow);

            setErrors((prev) => {
               const obj = { ...prev };
               delete obj['header.accountId'];
               return obj;
            });
         }

         if (name === 'warehouseId') {
            const newRow = { ...row };
            newRow.header[name] = value;
            newRow.lineItem = newRow.lineItem.map((item) => ({
               ...item,
               [name]: value,
               stock: Array.isArray(item.stock)
                  ? item.stock.map((stockItem) => ({
                     ...stockItem,
                     [name]: stockItem.warehouseId ? stockItem.warehouseId : value,
                  }))
                  : [], // fallback if stock is not array
            }));
            setRow(newRow);
            setErrors((prev) => {
               const obj = prev;
               delete obj['header.brokerId'];
               return obj;
            });
         }

         if (name === 'brokerId') {
            const newRow = { ...row };
            newRow.header[name] = value;
            setRow(newRow);
            setErrors((prev) => {
               const obj = prev;
               delete obj['header.brokerId'];
               return obj;
            });
         }

         if (name === 'transportId') {
            const newRow = { ...row };
            newRow.header[name] = value;
            setRow(newRow);
            setErrors((prev) => {
               const obj = prev;
               delete obj['header.transportId'];
               return obj;
            });
         }

         if (name === 'vehicleId') {
            const newRow = { ...row };
            newRow.header[name] = value;
            setRow(newRow);
            setErrors((prev) => {
               const obj = prev;
               delete obj['header.vehicleId'];
               return obj;
            });
         }

         if (name === 'representativeId') {
            const newRow = { ...row };
            newRow.header[name] = value;
            setRow(newRow);
            setErrors((prev) => {
               const obj = prev;
               delete obj['header.representativeId'];
               return obj;
            });
         }
      },
      [row],
   );

   const handleStockModal = useCallback(
      (itemId, index) => {
         const selectedItem = itemData?.find((item) => item.id.toString() === itemId.toString());
         if (
            selectedItem &&
            selectedItem.itemdetailtype === 1
            // businessTypes?.businessType?.toUpperCase() === 'MOBILE'
         ) {
            onOpenModal();
         }

         if (
            daybook &&
            daybook?.getLineDetail &&
            selectedItem &&
            selectedItem?.id &&
            selectedItem?.id > 0 &&
            businessTypes?.businessType?.toUpperCase() === 'TEXTILE'
         ) {
            const itemData = row.lineItem[Number(index)];
            if (daybook?.getLineDetail && daybook?.isMillIssue && (itemData?.pliId || itemData?.pcliId)) {
               const selectedTakaDetails = itemData?.takaDetails?.map((i) => {
                  return {
                     ...i,
                     quantity3: i.quantity3,
                     itenName: i.itemName,
                     itemId: i.itemId,
                     purchaseLineItemId: i.purchaseLineItemId,
                     pcldId: i.pcldId,
                     isSelected: i.isSelected || true,
                  };
               })
               const std = Array.isArray(selectedTakaDetails) && selectedTakaDetails.length > 0 ? selectedTakaDetails : [];
               setTakaDetails(std);
               onOpenTakaDetailModal();
            } else {
               onOpenTakaModal();
            }
         }
      },
      [
         businessTypes?.businessType,
         daybook,
         itemData,
         onOpenModal,
         onOpenTakaDetailModal,
         onOpenTakaModal,
         purchase,
         row.lineItem,
      ],
   );

   const handleOnChange = async (header, name, value, idx) => {
      const newRow = { ...row };
      const lineItem = newRow.lineItem[idx];

      if (['qty1', 'qty2', 'qty3'].includes(name)) {
         handleQtyChange(name, value, idx);
      }
      if (name === 'itemRate') {
         handleRateChange(name, value, idx);
      }
      if (name === 'gstWithRate') {
         const gstRate = Number(value || 0);
         const gstPercent = Number(newRow[header][idx].gst || 0);
         const itemRate = gstRate / (1 + gstPercent / 100);
         handleRateChange('itemRate', Number(itemRate || 0)?.toFixed(2), idx);
      }
      if (name === 'amount') {
         const selectedItem = itemData.find((i) => i.id === newRow[header][idx].itemId);
         const unit = newRow[header][idx].unit;
         const qty =
            unit === selectedItem?.uqc1Data?.id
               ? newRow[header][idx].qty1
               : unit === selectedItem?.uqc2Data?.id
                  ? newRow[header][idx].qty2
                  : unit === selectedItem?.uqc3Data?.id
                     ? newRow[header][idx].qty3
                     : newRow[header][idx].qty1;
         const itemRate = Number(value || 0) / qty;
         const gstPercent = Number(newRow[header][idx].gst || 0);
         const gstRate = itemRate * (1 + gstPercent / 100);
         newRow[header][idx].gstWithRate = gstRate;
         handleRateChange('itemRate', itemRate, idx);
      }
      if (name === 'taxableAmount') {
         const selectedItem = itemData.find((i) => i.id === newRow[header][idx].itemId);
         const unit = newRow[header][idx].unit;
         const qty =
            unit === selectedItem?.uqc1Data?.id
               ? newRow[header][idx].qty1
               : unit === selectedItem?.uqc2Data?.id
                  ? newRow[header][idx].qty2
                  : unit === selectedItem?.uqc3Data?.id
                     ? newRow[header][idx].qty3
                     : newRow[header][idx].qty1;
         const itemRate = Number(value || 0) / qty;
         const gstPercent = Number(newRow[header][idx].gst || 0);
         const gstRate = itemRate * (1 + gstPercent / 100);
         newRow[header][idx].gstWithRate = gstRate;
         handleRateChange('itemRate', itemRate, idx);
      }
      if (['addLess1Percent', 'addLess2Percent', 'addLess3Percent'].includes(name)) {
         handleDiscountChange(name, value, idx);
      }

      if (name === 'unit') {
         handleUnitChange(value, idx);
      }

      if (name === 'itemId') {
         const selectedItem = itemData.find((x) => x.id === Number(value));
         newRow[header][idx].unit = selectedItem?.ratepersalesid;
         setCurrentLineItemIdx(idx);
         handleQtyChange('qty1', 0, idx);
         handleQtyChange('qty2', 0, idx);
         handleQtyChange('qty3', 0, idx);
         handleRateChange('itemRate', 0, idx);
         handleDiscountChange('addLess1Percent', 0, idx);
         handleDiscountChange('addLess2Percent', 0, idx);
         handleDiscountChange('addLess3Percent', 0, idx);
         handleItemChange(name, value, idx, 'issue');
         if (businessTypes?.businessType?.toUpperCase() === 'MOBILE') {
            await dispatch(
               getStock({
                  itemId: Number(value),
                  companyId: user?.loginhistory?.companyId,
                  type: 'issue',
               }),
            );
         }
         newRow.lineItem[idx].stock = [];
         handleStockModal(value, idx);
      }

      if (name === 'itemScreenId') {
         // const selectedItem = itemData.find((x) => x.id === Number(value));
         newRow[header][idx].itemScreenId = Number(value);
      }
      if (name === 'lotNumber') {
         newRow[header][idx].lotNumber = Number(value);
      }

      const daybook = filteredDaybooks.find((item) => item.id === row?.header?.daybookId);
      let subHsn;
      if (company?.setting?.applyGST && daybook?.applyGst && invoiceType !== 'issue' && newRow[header][idx].itemId) {
         if (name === 'typeOfSupply') {
            if (value === 1) {
               if (lineItem?.hsnData?.subHsn.length === 1) {
                  subHsn = lineItem?.hsnData?.subHsn[0];
               } else {
                  subHsn = lineItem?.hsnData?.subHsn?.find(
                     (hsn) => lineItem.itemRate >= hsn.fromRate && lineItem.itemRate <= hsn.toRate,
                  );
               }
            }
            if (value === 2) {
               if (lineItem?.hsnData?.subHsn.length === 1) {
                  subHsn = lineItem?.hsnData?.subHsn[0];
               } else {
                  subHsn = lineItem?.sacData?.subHsn?.find(
                     (hsn) => lineItem.itemRate >= hsn.fromRate && lineItem.itemRate <= hsn.toRate,
                  );
               }
            }
            const taxRate = parseFloat(subHsn?.gst) / 100;
            newRow[header][idx].gst = subHsn?.gst ?? 0;
            newRow[header][idx].gstAmount = lineItem.itemRate * lineItem.qty1 * taxRate;
            newRow[header][idx].ratio = subHsn?.ratio ?? null;
         }
      }
      newRow[header][idx][name] = value;
      setRow(newRow);
      setErrors((prev) => {
         const obj = prev;
         const fullName = `${header}[${idx}].${name}`;
         delete obj[fullName];
         return obj;
      });
   };

   const handleBillTermChange = useCallback(
      (index, values) => {
         setBillTerms((prev) => {
            const newBillTerms = [...prev];
            newBillTerms[index] = {
               ...newBillTerms[index],
               ...values,
            };
            const currentBasicAmount = parseFloat(row.header.basicAmount) || 0;
            let additionTotal = 0;
            let deductionTotal = 0;

            newBillTerms.forEach((term, idx) => {
               const amount = parseFloat(term.amount) || 0;
               const termData = billTermData[idx];

               if (termData?.signname === 'Subtraction') {
                  deductionTotal += Math.abs(amount);
               } else if (termData?.signname === 'Addition') {
                  additionTotal += Math.abs(amount);
               } else if (termData?.signname === 'Both') {
                  if (amount < 0) {
                     deductionTotal += Math.abs(amount);
                  } else {
                     additionTotal += amount;
                  }
               }
            });
            const netAmount = currentBasicAmount + additionTotal - deductionTotal;

            let billTerm = additionTotal - deductionTotal;
            let netTotal = totals.netAmount + additionTotal;
            netTotal = netTotal - deductionTotal;
            setBillTerm(billTerm);
            setTotalBillTermAmount(netTotal);
            setRow((prev) => ({
               ...prev,
               header: {
                  ...prev.header,
                  additionAmount: additionTotal.toFixed(2),
                  deductionAmount: deductionTotal.toFixed(2),
                  netAmount: netAmount.toFixed(2),
                  basicAmount: currentBasicAmount.toFixed(2),
               },
            }));

            return newBillTerms;
         });
      },
      [billTermData, row.header.basicAmount, setBillTerm, setTotalBillTermAmount, totals.netAmount],
   );

   const addLineItem = () => {
      setRow((prev) => ({
         ...prev,
         lineItem: [...prev.lineItem, { ...initialLineItem }],
      }));
   };

   const removeLineItem = (index, id) => {
      if (id) {
         Swal.fire({
            title: 'Are you sure?',
            text: `This entry is marked for removal/emptying. Please ensure this entry is saved permanently before proceeding.`,
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Yes, delete it!',
         }).then((result) => {
            if (result.isConfirmed) {
               setRow((prev) => ({
                  ...prev,
                  lineItem: prev.lineItem
                     .map((li, idx) => {
                        if (!li.itemId) return null;
                        return li.id === id ? { ...li, isDeleted: true } : li;
                     })
                     .filter(Boolean),
               }));
            }
         });
      } else {
         setRow((prev) => ({
            ...prev,
            lineItem: prev.lineItem.filter((_, i) => i !== index),
         }));
      }
   };

   const handleDelete = () => {
      if (deleteLineItemId) dispatch(deleteSalesLineItem(deleteLineItemId));
      if (row.lineItem?.length >= 0) {
         setRow((prev) => ({
            ...prev,
            lineItem: prev.lineItem.filter((_, i) => i !== currentLineItemIdx),
         }));
      }
      setDeleteLineItemId(null);
      onCloseDeleteModal();
      setCurrentLineItemIdx(null);
   };

   const removeStock = useCallback(
      (stock) => {
         const updatedLineItem = row.lineItem.map((lineItem, idx) => {
            const selectedItem = itemData.find((i) => i.id === lineItem.itemId);
            const stockData = lineItem.stock.filter((s) => s.serialNo !== stock.serialNo);
            const qty1 = stockData?.length;

            if (selectedItem && selectedItem?.itemdetailtype === 1 && qty1 === 0) {
               handleQtyChange('qty1', qty1, idx);
               itemRefs.current[idx].focus();
               return { ...lineItem, itemId: '', stock: [], qty1: qty1, itemRate: 0 };
            }
            if (selectedItem && selectedItem?.itemdetailtype === 1 && qty1 > 0) {
               handleQtyChange('qty1', qty1, idx);
               return { ...lineItem, stock: stockData, qty1: qty1 };
            }

            return lineItem;
         });

         setRow((prev) => ({
            ...prev,
            lineItem: updatedLineItem,
         }));
      },
      [handleQtyChange, itemData, row.lineItem],
   );

   const handleEditValues = useCallback(async () => {
      if (id && salesInvoice) {
         setRow({
            header: {
               daybookId: salesInvoice.daybookId,
               docno: salesInvoice.docno,
               transactionAt: salesInvoice.transactionAt ? moment(salesInvoice.transactionAt, [moment.ISO_8601, "DD-MM-YYYY", "DD/MM/YYYY", "YYYY-MM-DD", "YYYY/MM/DD"]).format('YYYY-MM-DD') : '',
               dueAt: salesInvoice.dueAt ? new Date(salesInvoice.dueAt).toISOString().split('T')[0] : '',
               dueDays: salesInvoice.dueDays,
               accountId: salesInvoice.accountId,
               basicAmount: salesInvoice.basicAmount,
               netAmount: salesInvoice.netAmount,
               notes: salesInvoice.notes,
               transportId: salesInvoice.transportId,
               vehicleId: salesInvoice.vehicleId,
               representativeId: salesInvoice.representativeId,
               brokerId: salesInvoice.brokerId,
               prefix: (() => {
                  const db = daybookData?.find((d) => d.id === salesInvoice.daybookId);
                  const sep = db?.separator || '';
                  if (!sep) return salesInvoice.prefix || '';
                  const escaped = sep.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
                  return (salesInvoice.prefix || '').replace(new RegExp(escaped + '$', ''), '');
               })(),
               postFix: (() => {
                  const db = daybookData?.find((d) => d.id === salesInvoice.daybookId);
                  const sep = db?.separator || '';
                  if (!sep) return salesInvoice.postFix || '';
                  const escaped = sep.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
                  return (salesInvoice.postFix || '').replace(new RegExp('^' + escaped, ''), '');
               })(),
            },
            lineItem: salesInvoice.lineitems?.map((item, index) => {
               const isDisabled = (item?.issueLineDetail ?? []).some(ld => ld?.minQty3 > 0);
               const processStatus = [
                  ...new Set(
                     item?.issueLineDetail
                        ?.map((a) => a.processStatus)
                        ?.filter(Boolean)
                  )
               ];
               setFiledDisabled(businessTypes?.businessType?.toUpperCase() === 'TEXTILE' ? isDisabled : processStatus?.includes("PURCHASE"));
               return {
                  ...item,
                  itemRate: item.itemRate?.toString(),
                  amount: item.amount,
                  typeOfSupply: Number(item.typeOfSupply),
                  netAmount: item.netAmount,
                  taxableAmount: item.taxableAmount,
                  ratio: item.ratio,
                  addLess1Percent: item.addLess1Percent,
                  addLess1Amount: item.addLess1Amount,
                  addLess2Percent: item.addLess2Percent,
                  addLess2Amount: item.addLess2Amount,
                  addLess3Percent: item.addLess3Percent,
                  addLess3Amount: item.addLess3Amount,
                  qty1: item.qty1,
                  qty2: item.qty2 ?? 0,
                  qty3: item.qty3 ?? 0,
                  gst: item.gstPercent,
                  unit: item.ratePer,
                  isDeleted: false,
                  isDisabled: isDisabled ? true : false,
                  notes: item.notes ? item.notes : '',
                  remarks: item.remarks ? item.remarks : '',
                  gstWithRate: item.gstWithRate ? item.gstWithRate : null,
                  pliId: item.pliId,
                  pcliId: item.pcliId,
                  isDisItem: processStatus?.includes("PURCHASE"),
                  isDisItemRate: processStatus?.includes("PURCHASE"),
                  processStatus: processStatus,
                  stock: Array.isArray(item?.issueLineDetail) && item?.issueLineDetail?.length > 0 && businessTypes?.businessType?.toUpperCase() === "MOBILE" ? item?.issueLineDetail?.map((stock) => {
                     return {
                        ...stock,
                        pcs: stock.quantity1,
                     };
                  }) : [],
                  takaDetails: Array.isArray(item?.issueLineDetail) && item?.issueLineDetail?.length > 0 && businessTypes?.businessType?.toUpperCase() !== "MOBILE" ? item?.issueLineDetail?.map((x) => {
                     return { ...x, quantity3: x.quantity3, isSelected: true };
                  }) : [],
               };
            }),
         });

         const dbOrig = daybookData?.find((d) => d.id === salesInvoice.daybookId);
         const sepOrig = dbOrig?.separator || '';
         setOriginalPrefix(
            sepOrig
               ? (salesInvoice.prefix || '').replace(new RegExp(sepOrig.replace(/[.*+?^${}()|[\]\\]/g, '\\$&') + '$', ''), '')
               : (salesInvoice.prefix || '')
         );
         setOriginalPostFix(
            sepOrig
               ? (salesInvoice.postFix || '').replace(new RegExp('^' + sepOrig.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'), ''), '')
               : (salesInvoice.postFix || '')
         );

         const initialBillTerms = billTermData?.map((term) => {
            const billTerm = salesInvoice.issueBillTerms?.find((billTerm) => billTerm.billTermId === term.id);
            if (billTerm) {
               return {
                  id: billTerm?.id,
                  billTermId: term.id,
                  percentage: billTerm?.percentage || 0,
                  amount: billTerm?.amount || 0,
               };
            } else {
               return {
                  billTermId: term.id,
                  percentage: 0,
                  amount: 0,
               };
            }
         });
         setBillTerms(initialBillTerms);
      }
   }, [dispatch, id, salesInvoice, billTermData.length, setFiledDisabled]);
   // billTermData, dispatch, hasFetchedAccount, id, salesInvoice

   const handleInputChange = useCallback((header, e, idx) => {
      const { name, value } = e.target;

      setRow((prev) => ({
         ...prev,
         [header]: {
            ...prev[header],
            [name]: value,
         },
      }));

      if (name === 'dueDays') {
         setRow((prev) => {
            const transactionDate = prev[header]?.transactionAt ? moment(prev[header].transactionAt).clone() : moment(); // fallback if missing

            return {
               ...prev,
               [header]: {
                  ...prev[header],
                  dueAt: transactionDate.add(Number(value), 'days').format('YYYY-MM-DD'),
               },
            };
         });
      }

      if (name === 'dueAt') {
         setRow((prev) => {
            const transactionDate = prev[header]?.transactionAt; // "YYYY-MM-DD"

            const dueDate = moment(value, 'YYYY-MM-DD'); // user's selected due date
            const transDate = moment(transactionDate, 'YYYY-MM-DD');

            const diffDays = dueDate.diff(transDate, 'days'); // <-- main logic

            return {
               ...prev,
               [header]: {
                  ...prev[header],
                  dueDays: diffDays, // store difference in days
               },
            };
         });
      }

      if (name === 'transactionAt') {
         setRow((prev) => {
            const dueDays = Number(prev[header]?.dueDays || 0);

            // new transaction date user selected
            const transactionDate = moment(value, 'YYYY-MM-DD').clone();

            return {
               ...prev,
               [header]: {
                  ...prev[header],
                  transactionAt: value,
                  dueAt: transactionDate.add(dueDays, 'days').format('YYYY-MM-DD'),
               },
            };
         });
      }

      setErrors((prev) => {
         const obj = prev;
         const fullName = `${header}.${name}`;
         delete obj[fullName];
         return obj;
      });
   }, []);

   const handleWarehouseId = useCallback(
      (warehouseId) => {
         const warehouseIn =
            daybook?.warehouseInId === 1 || companyData?.setting?.warehouseInPurchase === 1
               ? [1]
               : daybook?.warehouseInId === 2 || companyData?.setting?.warehouseInPurchase === 2
                  ? [1, 2]
                  : [1, 2, 3];
         if (companyData?.setting?.warehouseWishStock) {
            if (
               (warehouseIn.includes(daybook?.warehouseInId) ||
                  warehouseIn.includes(companyData?.setting?.warehouseInPurchase)) &&
               warehouseId &&
               warehouseId > 0
            )
               return warehouseId;
            if (warehouseIn.includes(daybook?.warehouseInId) && daybook?.wareHouseId && daybook?.wareHouseId > 0) {
               return daybook?.wareHouseId;
            }
            if (
               warehouseIn.includes(companyData?.setting?.warehouseInPurchase) &&
               companyData?.setting?.warehouseId &&
               companyData?.setting?.warehouseId > 0
            ) {
               return companyData?.setting?.warehouseId;
            }
         }
         return 1;
      },
      [companyData?.setting?.warehouseWishStock, daybook?.warehouseInId, daybook?.wareHouseId],
   );

   const saveData = _.debounce(
      async () => {
         const isValid = await validateForm();
         if (isValid) {

            const prefixChanged = row.header.prefix !== originalPrefix;
            const postFixChanged = row.header.postFix !== originalPostFix;

            if (prefixChanged || postFixChanged) {
               const result = await Swal.fire({
                  title: 'Prefix / Suffix Changed',
                  text: 'Do you want to update this change in the Daybook as well?',
                  icon: 'question',
                  showCancelButton: true,
                  confirmButtonText: 'Yes, Update Daybook',
                  cancelButtonText: 'No, Only This Bill',
                  confirmButtonColor: '#3085d6',
                  cancelButtonColor: '#6c757d',
                  focusCancel: true,
                  customClass: {
                     cancelButton: 'swal-focused-btn',
                  },
                  didOpen: () => {
                     const style = document.createElement('style');
                     style.id = 'swal-focus-style';
                     style.innerHTML = `
                     .swal-focused-btn {
                        outline: 3px solid #fff !important;
                        outline-offset: 2px !important;
                        box-shadow: 0 0 0 4px rgba(108, 117, 125, 0.7) !important;
                        transform: scale(1.03) !important;
                     }
                  `;
                     document.head.appendChild(style);
                  },
                  didClose: () => {
                     const style = document.getElementById('swal-focus-style');
                     if (style) style.remove();
                  },
               });

               if (result.isConfirmed) {
                  const selectedDaybookToUpdate = daybookData?.find(
                     (db) => db.id === Number(row.header.daybookId)
                  );
                  if (selectedDaybookToUpdate) {
                     await dispatch(updateDaybook({
                        // ...selectedDaybookToUpdate,
                        id: selectedDaybookToUpdate.id,
                        name: selectedDaybookToUpdate.name,
                        type: Number(selectedDaybookToUpdate.type),
                        subType: Number(selectedDaybookToUpdate.subType) || 0,
                        accountId: Number(selectedDaybookToUpdate.accountId),
                        prefix: row.header.prefix,
                        suffix: row.header.postFix,
                     }));
                     setOriginalPrefix(row.header.prefix);
                     setOriginalPostFix(row.header.postFix);
                  }
               }
            }

            setIsLoading(true);
            const currentDaybookForSep = daybookData?.find((db) => db.id === Number(row.header.daybookId));
            const sep = currentDaybookForSep?.separator || '';
            const prefixToSave = (sep && row.header.prefix) ? `${row.header.prefix}${sep}` : (row.header.prefix || '');
            const suffixToSave = (sep && row.header.postFix) ? `${sep}${row.header.postFix}` : (row.header.postFix || '');

            const payload = {
               header: {
                  ...row.header,
                  ...(id && { id: id }),
                  docno: row.header?.docno?.toString()?.trim(),
                  prefix: prefixToSave,
                  postFix: suffixToSave,
                  basicAmount: formatAmount(Number(totals.netAmount)),
                  voucherId: voucher,
                  netAmount: formatAmount(Math.round(Number(finalNetAmount))),
                  companyId: Number(user?.loginhistory?.companyId),
                  accountId: Number(row.header.accountId),
                  daybookId: Number(row.header.daybookId),
                  additionAmount: row.header.additionAmount ? Number(row.header.additionAmount) : 0,
                  deductionAmount: row.header.deductionAmount ? Number(row.header.deductionAmount) : 0,
                  dueDays: row.header.dueDays ? Number(row.header.dueDays) : 0,
                  // transactionAt: moment(row.header.transactionAt).format('YYYY-DD-MM'),
                  transactionAt: moment(row.header.transactionAt, [moment.ISO_8601, "DD-MM-YYYY", "DD/MM/YYYY", "YYYY-MM-DD", "YYYY/MM/DD"]).format('YYYY-MM-DD'),
                  dueAt: moment(row.header.dueAt).format('YYYY-MM-DD'),
                  gstAmount: totals.netGstAmount ? totals.netGstAmount : 0,
                  // warehouseId:
                  //    companyData?.setting?.warehouseWishStock === true && herderview === true
                  //       ? row.header.warehouseId === null
                  //          ? selectdaybookdata?.wareHouseId ?? companyData?.setting?.warehouseId ?? 1
                  //          : row.header.warehouseId
                  //       : 1,
                  warehouseId: handleWarehouseId(row.header.warehouseId),
                  taxableAmount: totals.taxableAmount ? totals.taxableAmount : 0,
                  billtoStateId: getAccountAddress(accountData, row.header.accountId)?.billingAddress?.stateId ?? null,
                  shiptoStateId: getAccountAddress(accountData, row.header.accountId)?.shippingAddress?.stateId ?? null,
                  gstTxnType: getGstTaxType(companyList, accountData, 'sales'),
                  gstSubTxnType: getGstSubTaxType(companyList, accountData, 'sales'),
                  assesseType: companyList?.assesseType ? companyList?.assesseType : 0,
                  distance: companyList?.distanceKM ? companyList?.distanceKM : 0,
                  brokerId: row.header.brokerId || null,
                  notes: row.header.notes || null,
                  transportId: row.header.transportId || null,
                  vehicleId: row.header.vehicleId || null,
                  representativeId: row.header.representativeId || null,
               },
               lineItem: row.lineItem?.map((item) => {
                  const selectedItem = itemData?.find((i) => i.id.toString() === item.itemId?.toString());
                  const purchaseDoc = purchase.map((x) => x.item_id === item?.itemId);

                  return {
                     ...(item.id && { id: item.id }),
                     typeOfSupply: item.typeOfSupply ? item.typeOfSupply : 1,
                     itemId: item.itemId ? Number(item.itemId) : 0,
                     lineNumber: item.lineNumber ? Number(item.lineNumber) : 1,
                     itemRate: item.itemRate ? Number(item.itemRate) : 0,
                     amount: item.amount ? Number(item.amount) : 0,
                     netAmount: item.netAmount ? formatAmount(Number(item.netAmount)) : 0,

                     ratePer: item.unit && item.unit > 0 ? item.unit : selectedItem.ratepersalesid,
                     uomNoForRate:
                        item.unit > 0 && item.unit === selectedItem.uqcid1
                           ? 1
                           : item.unit > 0 && item.unit === selectedItem.uqcid2
                              ? 2
                              : item.unit > 0 && item.unit === selectedItem.uqcid3
                                 ? 3
                                 : 1,
                     qUnitId1: selectedItem?.uqcid1,
                     qUnitId2: selectedItem?.uqcid2,
                     qUnitId3: selectedItem?.uqcid3,
                     qty1: item.qty1 ? Number(item.qty1 ?? 0) : 0,
                     qty2: item.qty2 ? Number(item.qty2 ?? 0) : 0,
                     qty3: item.qty3 ? Number(item.qty3 ?? 0) : 0,
                     addLess1Percent: item.addLess1Percent ? Number(item.addLess1Percent) : 0,
                     addLess1Amount: item.addLess1Amount ? item.addLess1Amount : 0,
                     addLess2Percent: item.addLess2Percent ? Number(item.addLess2Percent) : 0,
                     addLess2Amount: item.addLess2Amount ? item.addLess2Amount : 0,
                     addLess3Percent: item.addLess3Percent ? Number(item.addLess3Percent) : 0,
                     addLess3Amount: item.addLess3Amount ? item.addLess3Amount : 0,
                     taxableAmount: item.taxableAmount ? item.taxableAmount : 0,
                     netGst: item.netGst ? item.netGst : 0,
                     gstPercent: item.gst ? item.gst : 0,
                     cgst: isSameState ? totals.netGstAmount / 2 : 0,
                     sgst: isSameState ? totals.netGstAmount / 2 : 0,
                     igst: isSameState ? 0 : totals.netGstAmount,
                     // pchlnLineId: purchaseDoc?.purchase_line_item_id ? purchaseDoc?.purchase_line_item_id : 0,
                     pliId: item.pliId ? item.pliId : null,
                     pcliId: item.pcliId ? item.pcliId : null,
                     processStatus: undefined,
                     stock:
                        item.stock?.length > 0 && businessTypes?.businessType?.toUpperCase() === "MOBILE"
                           ? item.stock.map((s) => {
                              delete s.returnStatus;
                              delete s.stockStatus;
                              delete s.status;
                              delete s.issueStatus;
                              return {
                                 ...s,
                                 // warehouseId: s.warehouseId ? s.warehouseId : finalStockWarehouse,
                                 warehouseId: handleWarehouseId(s.warehouseId),
                                 returnStatus: undefined,
                                 warehouseName: undefined,
                                 status: undefined,
                                 issueStatus: undefined,
                                 processStatus: undefined,
                              };
                           })
                           : [],
                     takaDetails:
                        Array.isArray(item.takaDetails) && Array.from(item.takaDetails) && businessTypes?.businessType?.toUpperCase() !== "MOBILE"
                           ? item.takaDetails
                              .filter((a) => a.isSelected)
                              .map((t) => {
                                 return {
                                    ...(t.id && id && { id: t.id }),
                                    pinvLineDetailId: t?.purchase_line_detail_id ? t?.purchase_line_detail_id : t?.pinvLineDetailId ? t?.pinvLineDetailId : null,
                                    quantity3: t?.quantity3,
                                    pcldId: t?.pcldId ? t?.pcldId : null,
                                 };
                              })
                           : [],
                     hsnId: selectedItem?.hsnid,
                     sacId: selectedItem?.sacid,
                     // warehouseId: finalWarehouse,
                     warehouseId: handleWarehouseId(item.warehouseId),
                     isDeleted: item.isDeleted ? item.isDeleted : false,
                     notes: item.notes ? item.notes : null,
                     remarks: item.remarks ? item.remarks : null,
                     gstWithRate: item.gstWithRate ? item.gstWithRate : null,
                  };
               }),
               billTerm: billTerms?.map((term) => ({
                  ...(term.id && { id: term.id }),
                  billTermId: Number(term.billTermId),
                  percentage: Number(term.percentage),
                  amount: Number(term.amount),
               })),
            };

            const newPayload = { ...payload };
            newPayload.lineItem = newPayload?.lineItem?.map((item) => {
               const ldWarehouseIds = new Set(item?.stock?.map((stock) => stock?.warehouseId));
               const warehouseId = ldWarehouseIds.values().next().value;
               return {
                  ...item,
                  // warehouseId: ldWarehouseIds.size > 1 ? item?.warehouseId : warehouseId,
                  warehouseId: ldWarehouseIds.size > 1 ? 1 : warehouseId,
               };
            });

            const warehouseIds = new Set(newPayload?.lineItem?.map((item) => item?.warehouseId));
            const warehouseId = warehouseIds.values().next().value;
            // newPayload.header.warehouseId = warehouseIds.size > 1 ? newPayload?.header?.warehouseId : warehouseId
            newPayload.header.warehouseId = warehouseIds.size > 1 ? 1 : warehouseId;

            let res;
            if (id) {
               res = await dispatch(updateIssueInventory(newPayload));
            } else {
               res = await dispatch(addIssueInventory(newPayload));
            }

            if (res?.code === 2) {
               setIsLoading(false);
               return;
            }

            if (res?.code === 1) {
               if (user?.loginhistory?.companyId) {
                  dispatch(
                     getDaybook({
                        companyId: Number(user?.loginhistory?.companyId),
                        ...(shouldSendCompanyIdDaybook && { companyIds: user?.loginhistory?.companyId }),
                     }),
                  );
                  dispatch(
                     getItem({
                        companyId: user?.loginhistory.companyId,
                        sortBy: 'name',
                        sortOrder: 'asc',
                        ...(shouldSendCompanyIdItem && { companyIds: user?.loginhistory?.companyId }),
                     }),
                  );
                  dispatch(
                     getAccount({
                        compId: Number(user?.loginhistory?.companyId),
                        accountTypes: ['K', 'E', 'C', 'D', 'BROKER', 'I', 'L', 'M', 'N', 'A'].join(','),
                        status: true,
                        ...(shouldSendCompanyIdAccount && { companyIds: user?.loginhistory?.companyId }),
                     }),
                  );
               }
               if (daybook?.onlinePrinting) {
                  if (daybook?.askBeforePrint) {
                     Swal.fire({
                        title: 'Do you want to Print Document?',
                        showCancelButton: true,
                        confirmButtonText: 'Yes',
                        cancelButtonText: 'No',
                        cancelButtonColor: '#d33',
                        confirmButtonColor: '#3085d6',
                     }).then(async (result) => {
                        /* Read more about isConfirmed, isDenied below */
                        if (result.isConfirmed) {
                           if (daybook?.printingSettings === 0) {
                              await dispatch(
                                 getSetupFormat({
                                    companyId: user?.loginhistory?.companyId,
                                    daybookId: row.header.daybookId,
                                    functionName: 'Sales Invoice',
                                 }),
                              );

                              const defaultFormat = prints.find((a) => a.isDefault);
                              if (defaultFormat) {
                                 const result = await dispatch(
                                    setupFormatCustomQuery({
                                       query: defaultFormat?.PrintFormat?.query,
                                    }),
                                 );
                                 if (result && result?.data && result?.data?.length > 0) {
                                    const html = injectDataIntoHtml(
                                       defaultFormat?.PrintFormat?.html,
                                       result?.data?.length > 0 ? result?.data : [],
                                    );
                                    handleReset();
                                    handlePrintClick(
                                       {},
                                       html,
                                       defaultFormat?.PrintFormat?.css,
                                       navigate,
                                       '/admin/inventory/issue',
                                    );
                                 }
                              }
                           } else {
                              handleReset();
                              onOpenPrintFormatModal();
                           }
                        }

                        if (result.isDismissed) {
                           setVoucher(null);
                           dispatch(emptyIssueInventory());
                           await dispatch(
                              getIssueInventories({
                                 page: 1,
                                 limit: 10,
                                 companyId: user?.loginhistory?.companyId,
                                 sortBy: 'id',
                                 sortOrder: 'desc',
                                 isReturn: false,
                              }),
                           );
                           localStorage.removeItem('daybook');
                           localStorage.removeItem('accountId');
                           setIsLoading(false);
                           handleReset();
                           navigate('/admin/inventory/issue');
                           return;
                        }
                     });
                     return;
                  }
               }

               setVoucher(null);
               dispatch(emptyIssueInventory());
               await dispatch(
                  getIssueInventories({
                     page: 1,
                     limit: 10,
                     companyId: user?.loginhistory?.companyId,
                     sortBy: 'id',
                     sortOrder: 'desc',
                     isReturn: false,
                  }),
               );
               localStorage.removeItem('daybook');
               localStorage.removeItem('accountId');
               setIsLoading(false);
               handleReset();
               navigate('/admin/inventory/issue');
               return;
            } else {
               toast({
                  title: 'Validation Error',
                  description: getFirstErrorMessage(errors),
                  status: 'error',
                  duration: 3000,
                  isClosable: true,
               });
            }

            setIsLoading(false);
         } else {
            toast({
               title: 'Validation Error',
               description: getFirstErrorMessage(errors),
               status: 'error',
               duration: 3000,
               isClosable: true,
            });
            setIsLoading(false)
         }
      },
      500,
      { leading: true, trailing: true },
   );

   // const handleSubmit = useCallback(async () => {
   //    setIsLoading(true);
   //    const now = Date.now();
   //    if (now - lastClick.current < 1000) return;
   //    lastClick.current = now;

   //    const financialYear = financialYears.find((a) => a.financial_year === user?.financialYear);

   //    const data = {
   //       daybookId: row.header.daybookId,
   //       docno: row.header.docno,
   //       fromDate: moment(financialYear?.fy_start_date, 'DD/MM/YYYY').format('YYYY-MM-DD'),
   //       toDate: moment(financialYear?.fy_end_date, 'DD/MM/YYYY').format('YYYY-MM-DD'),
   //       companyId: user?.loginhistory?.companyId,
   //    };
   //    if (id) data.id = Number(id);
   //    const res = await dispatch(checkDocNo(data));
   //    if (res && res.code === 1 && res.data?.isError) {
   //       Swal.fire({
   //          title: res?.data?.message,
   //          showCancelButton: true,
   //          confirmButtonText: 'Yes',
   //          cancelButtonText: 'No',
   //          cancelButtonColor: '#d33',
   //          confirmButtonColor: '#3085d6',
   //       }).then(async (result) => {
   //          if (result.isConfirmed) {
   //             const newRow = { ...row };
   //             newRow.header.docno = res.data?.newDocNo.toString();
   //             setRow(newRow);
   //             await saveData();
   //          }

   //          if (result.isDismissed) {
   //             setIsLoading(false);
   //             return;
   //          }
   //       });
   //    } else {
   //       await saveData();
   //    }
   // }, [dispatch, id, row, saveData, user?.loginhistory?.companyId]);

   const handleSubmit = useCallback(async () => {
      const now = Date.now();
      if (now - lastClick.current < 1000) return;
      lastClick.current = now;

      setIsLoading(true);

      const isValid = await validateForm();
      if (!isValid) {
         toast({
            title: 'Validation Error',
            description: getFirstErrorMessage(errors),
            status: 'error',
            duration: 3000,
            isClosable: true,
         });
         setIsLoading(false);
         return;
      }

      const financialYear = financialYears.find((a) => a.financial_year === user?.financialYear);

      const data = {
         daybookId: row.header.daybookId,
         docno: row.header.docno,
         fromDate: moment(financialYear?.fy_start_date, 'DD/MM/YYYY').format('YYYY-MM-DD'),
         toDate: moment(financialYear?.fy_end_date, 'DD/MM/YYYY').format('YYYY-MM-DD'),
         companyId: user?.loginhistory?.companyId,
      };
      if (id) data.id = Number(id);

      const res = await dispatch(checkDocNo(data));
      if (res && res.code === 1 && res.data?.isError) {
         Swal.fire({
            title: res?.data?.message,
            showCancelButton: true,
            confirmButtonText: 'Yes',
            cancelButtonText: 'No',
            cancelButtonColor: '#d33',
            confirmButtonColor: '#3085d6',
         }).then(async (result) => {
            if (result.isConfirmed) {
               const newRow = { ...row };
               newRow.header.docno = res.data?.newDocNo.toString();
               setRow(newRow);
               await saveData();
            }
            if (result.isDismissed) {
               setIsLoading(false);
               return;
            }
         });
      } else if (res && res.code === 1 && !res.data?.isError) {
         await saveData();
      } else {
         setIsLoading(false);
      }
   }, [dispatch, errors, financialYears, id, row, saveData, toast, user?.financialYear, user?.loginhistory?.companyId, validateForm]);

   const handleSelectStock = useCallback(
      (stocks) => {
         const newStock = stocks.map((stock) => {
            const purchaseLineDetailId =
               stock.daybooktype === 11 ? stock.id : stock.pinvLineDetailId ? stock.pinvLineDetailId : null;
            const receiveLineDetailId =
               stock.daybooktype === 20 ? stock.id : stock.receiveLineDetailId ? stock.receiveLineDetailId : null;
            const salesReturnLineDetailId =
               stock.daybooktype === 6
                  ? stock.id
                  : stock.salesReturnLineDetailId
                     ? stock.salesReturnLineDetailId
                     : null;
            const firstWarehouse = warehouseList.find((wh) => wh.id === 1);
            return {
               itemId: stock.itemId,
               itemName: stock.itemName,
               pcs: stock.pcs,
               serialNo: stock.serialNo,
               serialNo2: stock.serialNo2,
               barcode: stock.barcode,
               warehouseName: stock.warehouseName ? stock.warehouseName : firstWarehouse ? firstWarehouse?.name : '',
               warehouseId: stock.warehouseId ?? 1,
               isOld: stock.isOld,
               pinvLineDetailId: purchaseLineDetailId,
               receiveLineDetailId: receiveLineDetailId,
               salesReturnLineDetailId: salesReturnLineDetailId,
               itemRate: stock.itemRate,
               latest_transaction_type: stock.latest_transaction_type,
               gstWithRate: stock.gstWithRate,
               account: stock.account,
               transactionAt: stock.transactionAt,
               finalItemCost: stock.finalItemCost,
            };
         });

         const newRow = { ...row }
         const stockData = [...newStock];

         newRow.lineItem[currentLineItemIdx].stock = stockData;
         handleQtyChange('qty1', stockData?.length, currentLineItemIdx);
      },
      [currentLineItemIdx],
   );

   const handleAskToVerifyCustomer = useCallback(
      async (fields, paymentData) => {
         const isValid = await validateForm();
         if (isValid) {
            if (selectedDaybook?.isAskToAllow) {
               onOpenVerifyModal();
               return true;
            } else {
               handleSubmit();
            }
         } else {
            toast({
               title: 'Validation Error',
               description: getFirstErrorMessage(errors),
               status: 'error',
               duration: 3000,
               isClosable: true,
            });
            return false;
         }
      },
      [errors, handleSubmit, onOpenVerifyModal, selectedDaybook?.isAskToAllow, toast, validateForm],
   );

   const handleReset = useCallback(async () => {
      const initialRow = {
         header: {
            daybookId: lastDaybook?.daybookId || '',
            docno: '',
            postfix: '',
            prefix: '',
            transactionAt: new Date().toISOString().split('T')[0],
            companyId: '',
            accountId: '',
            brokerId: '',
            basicAmount: 0,
            additionAmount: '',
            deductionAmount: '',
            netAmount: 0,
            dueDays: 0,
            dueAt: new Date().toISOString().split('T')[0],
            billtoStateId: null,
            shiptoStateId: null,
            warehouseId: null,
            notes: '',
            vehicleId: null,
            transportId: null,
            representativeId: user?.id,
         },
         lineItem: [initialLineItem],
      };
      setRow(initialRow);
      setBillTerms([]);
      await dispatch(emptyIssueInventory());
      localStorage.removeItem('daybook');
      localStorage.removeItem('accountId');
   }, [dispatch, initialLineItem, lastDaybook?.daybookId, user?.id]);

   const getSalesInvoiceData = useCallback(async () => {
      if (id) dispatch(getIssueInventory(id));
   }, [dispatch, id]);

   const getData = useCallback(async () => {
      if (user && user?.loginhistory?.companyId) {
         await dispatch(
            getUsers(),
         );
         await dispatch(
            getWarehouse({ ...(shouldSendCompanyIdWarehouse && { companyIds: user?.loginhistory?.companyId }) }),
         );
         await dispatch(getFinancialYears({ companyId: user?.loginhistory?.companyId }));
      }
      await dispatch(getMainAndSubHsn());
      await dispatch(getGLGroupsAllDropdown());
      setIsPageLoading(false);
   }, [dispatch, user]);

   const handleSerialHistory = (item) => {
      setSelectedItem(item);
      dispatch(getSerialWiseHistory({ companyIds: user?.loginhistory?.companyId, serialNo: item.serialNo }));
   };

   const setLineItem = useCallback(() => {
      if (
         purchaseDoc.length > 0 &&
         businessTypes?.businessType?.toUpperCase() === 'TEXTILE' &&
         (daybook?.isMillIssue || daybook?.isOtherJobWork)
      ) {

         if (id) {
            const selectedTakaDetails = purchase?.filter((x) => purchaseDoc.includes(x.id))
            const newRows = { ...row };
            const editLineItem = newRows.lineItem.filter((item) => item.id)
            newRows.lineItem = newRows.lineItem.map((item) => {
               const newTakaDetails = selectedTakaDetails?.filter((x) => {
                  if (x.type?.toLowerCase() === "purchase" && x.itemId === item.itemId && item.pliId === x.id) return true
                  if (x.type?.toLowerCase() === "challan" && x.itemId === item.itemId && item.pcliId === x.id) return true
                  return false
               })
                  .flatMap((x) => {
                     return x?.purchaseLineDetail.map((a) => ({
                        itemName: item.itemName,
                        itemId: a.itemId,
                        pinvLineDetailId: x.type?.toLowerCase() === "purchase" ? a.id : null,
                        quantity1: a.pendingQty1,
                        quantity2: a.pendingQty2,
                        quantity3: a.pendingQty3,
                        isSelected: true,
                        id: a.id,
                        issueQty3: a.issueQty3,
                        purchaseQty3: a.pendingQty3,
                        pcldId: x.type?.toLowerCase() === "challan" ? a.id : null,

                     }))
                  })

               const oldTaka = Array.isArray(item?.issueLineDetail) && item?.issueLineDetail.length > 0 ? item?.issueLineDetail?.map((taka) => {
                  return {
                     ...taka,
                     isSelected: true,
                  };
               }) : []

               const newTd = mergeRecords([...oldTaka, ...newTakaDetails])
               const selectedItem = itemData.find((a) => a.id === item.itemId)
               return {
                  ...item,
                  unit: item.unit ? item?.unit : selectedItem?.ratepersalesid,
                  qty1: (newTd?.length || 0),
                  qty2: item.qty2,
                  qty3: newTd?.reduce((acc, curr) => acc + curr.quantity3, 0) || 0,
                  takaDetails: newTd,
               };
            })
            setRow(newRows);

            const lineItemIds = editLineItem.filter((a) => a.pliId || a.pcliId).map((x) => x.pliId ? x.pliId : x.pcliId ? x.pcliId : null).filter(Boolean)
            const selectedTakaDetailsIds = setLineItemData(selectedTakaDetails?.filter((x) => !lineItemIds.includes(x.id)), itemData)
            setRow((prev) => ({
               ...prev,
               lineItem: id && id > 0 ? [...prev.lineItem, ...selectedTakaDetailsIds] : selectedTakaDetailsIds,
            }));
            return;
         }
         const lineItem = setLineItemData(purchase?.filter((x) => purchaseDoc.includes(x.id)), itemData)
         setRow((prev) => ({
            ...prev,
            lineItem: id && id > 0 ? [...prev.lineItem, ...lineItem] : lineItem,
         }));
      }
   }, [businessTypes?.businessType, daybook?.isMillIssue, daybook?.isOtherJobWork, purchase, purchaseDoc]);

   useEffect(() => {
      if (user && (user.isExpired || !user?.packageData?.[0]?.issue)) {
         window.history.back();
      }
   }, [user]);

   useEffect(() => {
      if (!id) {
         const selectedAccount = accountData.find((ac) => ac.id === row.header.accountId);
         const selectedDaybook = daybookData.find((db) => db.id === row.header.daybookId);

         if (selectedAccount && selectedAccount?.defaultDueDays) {
            setRow((prev) => ({
               ...prev,
               header: {
                  ...prev.header,
                  dueDays: selectedAccount?.defaultDueDays,
                  dueAt: moment().add(Number(selectedAccount?.defaultDueDays), 'days').format('YYYY-MM-DD'),
               },
            }));
         } else if (selectedDaybook && selectedDaybook?.dueDays) {
            setRow((prev) => ({
               ...prev,
               header: {
                  ...prev.header,
                  dueDays: selectedDaybook?.dueDays,
                  dueAt: moment().add(Number(selectedDaybook?.dueDays), 'days').format('YYYY-MM-DD'),
               },
            }));
         } else {
            setRow((prev) => ({
               ...prev,
               header: {
                  ...prev.header,
                  dueDays: 0,
                  dueAt: moment().add(Number(0), 'days').format('YYYY-MM-DD'),
               },
            }));
         }
      }
   }, [row.header.daybookId, row.header.accountId]);

   useEffect(() => {
      const inventoryissueRight = Array.isArray(user?.userRights)
         ? user.userRights.find((right) => right.companyId === user?.loginhistory?.companyId)?.inventoryissue
         : null;

      if (user && !user?.isAdmin) {
         if (window.location.pathname.includes('inventory/issue/add') && inventoryissueRight) {
            if (inventoryissueRight?.add !== true) {
               window.history.back();
            }
         } else if (window.location.pathname.includes('inventory/issue/edit') && inventoryissueRight) {
            if (inventoryissueRight?.edit !== true) {
               window.history.back();
            }
         }
      }
   }, [user]);

   useEffect(() => {
      if (selectedItem && serialWiseHistory) {
         const historyForItem = serialWiseHistory?.flatMap((data) =>
            data.items
               .filter((subdata) => subdata.item_name === selectedItem.itemName)
               .flatMap((subdata) => subdata.transactions),
         );
         setData(historyForItem);
         onOpenSerialhistory();
      }
   }, [serialWiseHistory, selectedItem, onOpenSerialhistory]);

   const handleAdjustedDocs = () => {
      setShouldFetch(true);
      onOpenAdjustedDocs();
   };

   const handleSaveTakaDetail = useCallback(
      (data) => {
         const newRows = { ...row }
         const selectedTakaDetail = data.filter((a) => a.isSelected);
         const totalTakaDetails = selectedTakaDetail.reduce(
            (acc, item) => acc + Number(item?.quantity3 || 0),
            0,
         );
         newRows.lineItem[currentLineItemIdx].qty1 = selectedTakaDetail.length;
         newRows.lineItem[currentLineItemIdx].qty3 = totalTakaDetails;
         newRows.lineItem[currentLineItemIdx].takaDetails = selectedTakaDetail;
         setRow(newRows)
      },
      [currentLineItemIdx],
   );

   const handleTakaDetails = useCallback(
      (takaDetails) => {
         takaDetails = takaDetails
            ?.filter((q) => q.qty > 0)
            ?.map((t) => ({
               quantity1: 0,
               quantity2: 0,
               quantity3: t.qty ? Number(t.qty) : 0,
               notes1: '',
               issueLineDetailId: null,
               pinvLineDetailId: null,
               RQuantity1: 0,
               RQuantity2: 0,
               RQuantity3: t.qty ? Number(t.qty) : 0,
               isSelected: true,
            }));
         const totalTaka = takaDetails?.reduce((acc, item) => acc + Number(item?.quantity3 || 0), 0);

         setCurrentTakaDetails(takaDetails)
         let newRows = { ...row }
         const itemId = newRows.lineItem[currentLineItemIdx]?.itemId
         const selectedItem = itemData.find((i) => i.id === itemId);
         const unit = newRows.lineItem[currentLineItemIdx]?.unit ?? selectedItem.ratepersalesid;
         const qty1 = takaDetails?.length > 0 ? takaDetails?.length : 0;
         const qty2 = selectedItem?.defaultcut > 0 ? Number(selectedItem?.defaultcut) : 0;
         const qty3 = totalTaka;
         handleQtyChange('qty3', qty3, currentLineItemIdx);
         newRows.lineItem[currentLineItemIdx].unit = unit;
         newRows.lineItem[currentLineItemIdx].qty1 = qty1;
         newRows.lineItem[currentLineItemIdx].qty2 = qty2;
         newRows.lineItem[currentLineItemIdx].qty3 = qty3;
         newRows.lineItem[currentLineItemIdx].takaDetails = ([...takaDetails] || [])?.map((item) => ({
            ...item,
            itemId: itemId,
         }))
         setRow(newRows)
      },
      [currentLineItemIdx, handleQtyChange, itemData.length],
   );

   useEffect(() => {
      getData();
   }, [getData]);

   useEffect(() => {
      if (row.header.daybookId || lastDaybook?.daybookId) {
         const daybookId = row.header.daybookId ? row.header.daybookId : lastDaybook?.daybookId;
         dispatch(
            getBillTerm({
               daybookId: daybookId,
               ...(shouldSendCompanyidBillTerm && { companyIds: user?.loginhistory?.companyId }),
            }),
         );
      }
   }, [dispatch, lastDaybook?.daybookId, row.header.daybookId]);

   // edit data by id
   useEffect(() => {
      getSalesInvoiceData();
   }, [getSalesInvoiceData]);

   // set new create account id
   useEffect(() => {
      if (accountId) {
         setRow((prev) => ({
            ...prev,
            header: {
               ...prev.header,
               accountId: accountId,
            },
         }));
      }
   }, [accountId]);

   // set create account data
   useEffect(() => {
      handleEditValues();
   }, [handleEditValues]);

   // set last sale daybook
   useEffect(() => {
      if (lastDaybook && lastDaybook?.docno) {
         const currentDocNo = String(lastDaybook?.docno ?? 0);
         const nextDocNo =
            salesInvoice?.daybookId === lastDaybook?.daybookId
               ? salesInvoice?.docno
               : ((parseInt(currentDocNo) + 1).toString() ?? '1');

         if (!id) {
            const selectedDaybookForPrefix = daybookData?.find(
               (db) => db.id === Number(lastDaybook.daybookId)
            );
            const newRows = { ...row };
            newRows.header.daybookId = lastDaybook.daybookId;
            newRows.header.docno = nextDocNo;

            if (selectedDaybookForPrefix) {
               const sep = selectedDaybookForPrefix.separator || '';
               const escaped = sep ? sep.replace(/[.*+?^${}()|[\]\\]/g, '\\$&') : '';
               const cleanPrefix = sep
                  ? (selectedDaybookForPrefix.prefix || '').replace(new RegExp(escaped + '$', ''), '')
                  : (selectedDaybookForPrefix.prefix || '');
               const cleanSuffix = sep
                  ? (selectedDaybookForPrefix.suffix || '').replace(new RegExp('^' + escaped, ''), '')
                  : (selectedDaybookForPrefix.suffix || '');
               newRows.header.prefix = cleanPrefix;
               newRows.header.postFix = cleanSuffix;
               setOriginalPrefix(cleanPrefix);
               setOriginalPostFix(cleanSuffix);
            }
            newRows.lineItem = newRows.lineItem.map((item) => ({
               ...item,
               typeOfSupply: SupplyTypes?.find((item) => item.id === daybook?.typeOfSupply)?.id || 1,
            }));
            setRow(newRows);

         } else {
            // ✅ Edit mode — sirf docno update, prefix/suffix kabhi nahi
            setRow((prev) => ({
               ...prev,
               header: {
                  ...prev.header,
                  docno: nextDocNo,
               },
            }));
         }

      } else if (!id) {
         setRow((prev) => ({
            ...prev,
            header: {
               ...prev.header,
               docno: '1',
            },
            lineItem: prev.lineItem?.map((item) => ({
               ...item,
               typeOfSupply: SupplyTypes?.find((item) => item.id === daybook?.typeOfSupply)?.id || 1,
            })),
         }));
      }
   }, [daybook?.typeOfSupply, id, lastDaybook?.daybookId, lastDaybook?.docno, daybookData?.length]);

   useEffect(() => {
      if (daybookId) {
         setDaybookId(daybookId);
         setRow((prev) => ({
            ...prev,
            header: {
               ...prev.header,
               daybookId: Number(daybookId),
            },
         }));
      }
   }, [daybookId, setDaybookId]);

   useEffect(() => {
      if (billTermData && billTermData?.length > 0 && !id) {
         const initialBillTerms = billTermData?.map((term) => {
            return {
               billTermId: term.id,
               percentage: term.percentValue || 0,
               amount: 0,
            };
         });
         setBillTerms(initialBillTerms);
      }
   }, [billTermData, id]);

   useEffect(() => {
      if (row.header.accountId) {
         const state = account?.accountaddress?.find((a) => a.name === 'billing')?.stateId;
         const companyState = company?.stateid;
         setIsSameState(state?.toString() === companyState?.toString());
      }
   }, [account?.accountaddress, company?.stateid, row.header.accountId]);

   useEffect(() => {
      const stocks = row?.lineItem
         ?.filter((x) => x.isDeleted === false)
         ?.flatMap((li) => {
            if (!li.itemId) return [];
            return li.stock;
         });

      setRow((prevRow) => ({
         ...prevRow,
         lineItem: prevRow.lineItem?.map((item) => {
            if (!item.itemId) return { ...item, stock: [] };
            return item;
         }),
      }));

      setSelectedStocks(getUniqueByStock(stocks));
   }, [JSON.stringify(row.lineItem)]);

   useEffect(() => {
      const selectedStocks = row?.lineItem
         ?.filter((stock, idx) => stock.isDeleted === false && idx !== currentLineItemIdx)
         .flatMap((li) => li.stock.map((i) => i.serialNo?.trim()));
      setStockList(getUniqueByStock(stocks.filter((s) => !selectedStocks.includes(s.serialNo))));
   }, [stocks]);

   useEffect(() => {
      if (row.header.daybookId && user && user?.loginhistory?.companyId) {
         const daybookById = {
            id: Number(row.header.daybookId),
            compId: String(user?.loginhistory?.companyId),
         };
         dispatch(getDaybookById(daybookById));
      }
   }, [dispatch, row.header.daybookId, user]);

   useEffect(() => {
      if (!id) {
         if (row.header.daybookId || !row.header.daybookId) {
            if (daybookRef.current) {
               daybookRef.current.focus();
            }
         }
      }
   }, [id, row.header.daybookId]);

   useEffect(() => {
      if (row.lineItem?.length > 0) prepareRowRefs(row.lineItem?.length);
   }, [row.lineItem?.length]);

   useEffect(() => {
      if (billTermData?.length > 0) prepareBillTermRowRefs(billTermData?.length);
   }, [billTermData?.length]);

   // useEffect(() => {
   //    if (!id) {
   //       if (row.header.daybookId) {
   //          if (daybookRef.current) {
   //             daybookRef.current.focus();
   //          }
   //       }
   //    }
   // }, [id, row.header.daybookId, isPageLoading]);

   useEffect(() => {
      if (!id && !isPageLoading) {
         const timer = setTimeout(() => {
            if (daybookRef.current) {
               daybookRef.current.focus();
            }
         }, 100);
         return () => clearTimeout(timer);
      }
   }, [id, isPageLoading]);

   useEffect(() => {
      if (!id) {
         setRow((prev) => ({
            ...prev,
            header: { ...prev.header, representativeId: user?.id },
         }));
      }
   }, [id, user?.id]);

   const filteredDaybooks = daybookData.filter((item) => item.type === 19);
   const daybookbalance = filteredDaybooks.find((item) => item.id === row?.header?.daybookId)?.bal ?? null;

   useEffect(() => {
      const handleKeyDown = (e) => {
         if (e.key === 'Escape') {
            const activeElement = document.activeElement;

            if (activeElement !== docNoRef.current) {
               docNoRef.current?.focus();
            } else {
               window.history.back();
            }
         }
      };

      window.addEventListener('keydown', handleKeyDown);
      return () => {
         window.removeEventListener('keydown', handleKeyDown);
      };
   }, []);

   useEffect(() => {
      const fetchData = async () => {
         await dispatch(getGrayPurchasePendingIssue({
            companyId: user?.loginhistory?.companyId,
            ...(daybook?.challandaybookid && { pcDaybookId: daybook?.challandaybookid }),
            ...(daybook?.purchaseDaybookId && { purchaseDaybookId: daybook?.purchaseDaybookId }),
         }));
      }
      if (user?.loginhistory?.companyId) {
         if (
            businessTypes?.businessType?.toUpperCase() === 'TEXTILE' && daybook?.purchaseDaybookId &&
            (daybook?.isMillIssue || daybook?.isOtherJobWork)
         ) {
            fetchData()
         }
      }
      return () => { };
   }, [businessTypes?.businessType, daybook?.isMillIssue, daybook?.isOtherJobWork, dispatch, user?.loginhistory?.companyId]);

   useEffect(() => {
      setLineItem();
      return () => { };
   }, [setLineItem]);

   const selectdaybookdata = daybookData.find((daybook) => daybook.id === row.header.daybookId);
   const herderview =
      selectdaybookdata?.warehouseInId === 1
         ? true
         : selectdaybookdata?.warehouseInId === null
            ? companyData?.setting?.warehouseInInventory === 1
               ? true
               : false
            : false;
   const lineitemview =
      selectdaybookdata?.warehouseInId === 2
         ? true
         : selectdaybookdata?.warehouseInId === null
            ? companyData?.setting?.warehouseInInventory === 2
               ? true
               : false
            : false;
   const lineDetailview =
      selectdaybookdata?.warehouseInId === 3
         ? true
         : selectdaybookdata?.warehouseInId === null
            ? companyData?.setting?.warehouseInInventory === 3
               ? true
               : false
            : false;

   useEffect(() => {
      if (companyData?.setting?.warehouseWishStock === true) {
         if (herderview === true) {
            setRow((prev) => ({
               ...prev,
               header: {
                  ...prev.header,
                  warehouseId:
                     prev.header.warehouseId === null
                        ? selectdaybookdata?.wareHouseId
                           ? selectdaybookdata?.wareHouseId
                           : companyData?.setting?.warehouseId
                              ? companyData?.setting?.warehouseId
                              : 1
                        : prev.header.warehouseId,
               },
            }));
         }
      }
   }, [row.header.daybookId]);

   useEffect(() => {
      if (companyData?.setting?.warehouseWishStock === true) {
         if (lineitemview === true || lineDetailview === true) {
            setRow((prev) => ({
               ...prev,
               lineItem: Array.isArray(prev.lineItem)
                  ? prev.lineItem.map((item) => ({
                     ...item,
                     warehouseId:
                        item.warehouseId == null
                           ? selectdaybookdata?.wareHouseId
                              ? selectdaybookdata?.wareHouseId
                              : companyData?.setting?.warehouseId
                                 ? companyData?.setting?.warehouseId
                                 : 1
                           : item.warehouseId,
                  }))
                  : [],
            }));
         }
      }
   }, [row.header.daybookId, row.lineItem.length]);

   return (
      <>
         <Card
            flexDirection="column"
            w={{ base: '100%', md: '100%', xl: 'calc(100% - 00px)' }}
            px="0px"
            overflowX={{ sm: 'scroll', lg: 'hidden' }}
            mt="40px"
            position="relative"
            minH={'90vh'}
            maxH={'90vh'}
            overflowY={'scroll'}>
            <CardHeader>
               <Heading size="md">
                  <Flex gap={3} justifyContent="space-between" alignItems="center">
                     <Box>
                        <Flex gap={2} alignItems="center">
                           <img
                              src={back}
                              alt="Go Back"
                              width="15px"
                              onClick={() => {
                                 handleReset();
                                 window.history.back();
                              }}
                              style={{ cursor: 'pointer' }}></img>
                           {id ? 'Update' : 'Add'} Issue
                           {typeof daybookbalance === 'number' && daybookbalance !== 0 && (
                              <Text
                                 as="span"
                                 fontSize="sm"
                                 fontWeight="normal"
                                 ml={2}
                                 color={daybookbalance < 0 ? 'green.500' : 'red.500'}>
                                 (Balance:
                                 <>
                                    ₹{(Math.abs(daybookbalance)?.toFixed(2) || '0.00').split('.')[0]}.
                                    <Text as="span" fontSize="11px" verticalAlign="baseline">
                                       {(Math.abs(daybookbalance)?.toFixed(2) || '0.00').split('.')[1]}
                                    </Text>
                                 </>
                                 )
                              </Text>
                           )}
                        </Flex>
                     </Box>
                     {id && salesInvoice ? (
                        <Box>
                           <Flex gap={2} alignItems="center">
                              <Heading as="h3" size="lg">
                                 {salesInvoice?.pendingamt ? `₹${salesInvoice?.pendingamt}` : ''}
                              </Heading>
                              <Badge
                                 border="1px solid"
                                 bg="transparent"
                                 borderColor={pendingPayment?.borderColor}
                                 color={pendingPayment?.badgeColor}
                                 borderRadius="md"
                                 w="100%"
                                 textAlign="center"
                                 textTransform="capitalize">
                                 {salesInvoice?.pendingstatus?.replace(/\s*\[.*?\]/, '')?.trim()}
                              </Badge>
                              <Icon
                                 as={FaCircleInfo}
                                 boxSize={4}
                                 // ml={3}
                                 color="green.600"
                                 onClick={handleAdjustedDocs}
                                 cursor="pointer"
                              />
                           </Flex>
                        </Box>
                     ) : null}
                  </Flex>
               </Heading>
            </CardHeader>
            <CardBody>
               <Box position="relative">
                  {isPageLoading ? (
                     <Flex w="full" justifyContent="center" alignItems="center">
                        <Image src={loaderAnimation} width={150} height={150} objectFit="cover" />
                     </Flex>
                  ) : (
                     <>
                        <form>
                           <Grid templateColumns="repeat(4, 1fr)" gap={6}>
                              <GridItem w="100%">
                                 {renderDynamicDropdown(
                                    'daybookId',
                                    'Daybook',
                                    daybookData.filter((item) => item.type === 19),
                                    {
                                       errorName: 'header.daybookId',
                                       value: row.header.daybookId,
                                       onChange: (value) => handleDaybook('daybookId', value),
                                       focusBorderColor: 'blue.500',
                                       _focus: {
                                          boxShadow: '0 0 0 3px rgba(66, 153, 225, 0.6)',
                                       },
                                       disabled: businessTypes?.businessType?.toUpperCase() === 'TEXTILE' ? filedDisabled : false,
                                       ref: daybookRef,
                                       nextRef: docNoRef,
                                       showCustomNoOptions: true,
                                       openfrom: 'salesdaybook',
                                       type: 19,
                                    },
                                    errors,
                                    textColor,
                                    false,
                                    'Select Daybook',
                                 )}
                              </GridItem>

                              <GridItem colSpan={1}>
                                 <Flex gap={2}>
                                    <Box flex={1}>
                                       <InputField
                                          type="text"
                                          name="prefix"
                                          label="Prefix"
                                          value={(() => {
                                             const db = daybookData?.find((d) => d.id === Number(row.header.daybookId));
                                             const sep = db?.separator || '';
                                             const clean = row.header.prefix || '';
                                             if (!clean) return '';
                                             return sep ? `${clean}${sep}` : clean;
                                          })()}
                                          onChange={(e) => {
                                             const db = daybookData?.find((d) => d.id === Number(row.header.daybookId));
                                             const sep = db?.separator || '';
                                             const rawValue = e.target.value;
                                             let cleanValue = sep
                                                ? rawValue.replace(new RegExp(sep.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'), 'g'), '')
                                                : rawValue;
                                             cleanValue = cleanValue.replace(/[^A-Za-z0-9]/g, '');
                                             const sanitizedEvent = {
                                                ...e,
                                                target: { ...e.target, value: cleanValue, name: e.target.name },
                                             };
                                             handleInputChange('header', sanitizedEvent);
                                          }}
                                       // onKeyDown={(e) => handleKeyDown(e, docNoRef, daybookRef)}
                                       />
                                    </Box>
                                    <Box flex={1}>
                                       <InputField
                                          ref={docNoRef}
                                          type="text"
                                          name="docno"
                                          label="Doc No"
                                          value={row.header.docno}
                                          onChange={(e) => {
                                             const sanitizedValue = e.target.value.replace(/[^0-9]/g, '');
                                             const sanitizedEvent = {
                                                ...e,
                                                target: {
                                                   ...e.target,
                                                   value: sanitizedValue,
                                                   name: e.target.name,
                                                },
                                             };

                                             handleInputChange('header', sanitizedEvent);
                                          }}
                                          onKeyDown={async (e) => {
                                             if (e.key === 'PageUp') {
                                                e.preventDefault();
                                                if (!id) {
                                                   if (lastDaybook?.id)
                                                      navigate(`/admin/inventory/issue/edit/${lastDaybook?.id}`);
                                                } else {
                                                   const res = await dispatch(
                                                      getPrevAndNext({
                                                         id: id,
                                                         daybookId: row.header.daybookId,
                                                         companyId: user?.loginhistory?.companyId,
                                                      }),
                                                   );
                                                   if (res.prev) {
                                                      navigate(`/admin/inventory/issue/edit/${res.prev}`);
                                                   } else {
                                                      handleReset();
                                                      navigate(`/admin/inventory/issue/add`);
                                                   }
                                                }
                                                return;
                                             }
                                             if (e.key === 'PageDown') {
                                                e.preventDefault();
                                                if (!id) {
                                                   if (lastDaybook?.id)
                                                      navigate(`/admin/inventory/issue/edit/${lastDaybook?.id}`);
                                                } else {
                                                   const res = await dispatch(
                                                      getPrevAndNext({
                                                         id: id,
                                                         daybookId: row.header.daybookId,
                                                         companyId: user?.loginhistory?.companyId,
                                                      }),
                                                   );
                                                   if (res.next) {
                                                      navigate(`/admin/inventory/issue/edit/${res.next}`);
                                                   } else {
                                                      handleReset();
                                                      navigate(`/admin/inventory/issue/add`);
                                                   }
                                                }
                                                return;
                                             }
                                             handleKeyDown(e, transactionAtRef, daybookRef);
                                          }}
                                          autoFocus={id > 0 ? true : false}
                                       />
                                    </Box>
                                    <Box flex={1}>
                                       <InputField
                                          type="text"
                                          name="postFix"
                                          label="Suffix"
                                          value={(() => {
                                             const db = daybookData?.find((d) => d.id === Number(row.header.daybookId));
                                             const sep = db?.separator || '';
                                             const clean = row.header.postFix || '';
                                             if (!clean) return '';
                                             return sep ? `${sep}${clean}` : clean;
                                          })()}
                                          onChange={(e) => {
                                             const db = daybookData?.find((d) => d.id === Number(row.header.daybookId));
                                             const sep = db?.separator || '';
                                             const rawValue = e.target.value;
                                             let cleanValue = sep
                                                ? rawValue.replace(new RegExp(sep.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'), 'g'), '')
                                                : rawValue;
                                             cleanValue = cleanValue.replace(/[^A-Za-z0-9]/g, '');
                                             const sanitizedEvent = {
                                                ...e,
                                                target: { ...e.target, value: cleanValue, name: e.target.name },
                                             };
                                             handleInputChange('header', sanitizedEvent);
                                          }}
                                       // onKeyDown={(e) => handleKeyDown(e, transactionAtRef, docNoRef)}
                                       />
                                    </Box>
                                 </Flex>
                              </GridItem>

                              <GridItem w="100%" colSpan={2} rowSpan={2}>
                                 {account &&
                                    (account.mobile ||
                                       account.email ||
                                       account.panNo ||
                                       account.addressJson?.length > 0 ||
                                       account.gstRegNo ||
                                       account.brokername ||
                                       account.amt) ? (
                                    <Box
                                       border="1.5px solid"
                                       borderColor="gray.200"
                                       borderRadius="15px"
                                       padding="20px"
                                       marginLeft="40px"
                                       width="80%">
                                       {/* First Row: Mobile, Email, PAN */}
                                       <Flex gap={6} mb={4} flexWrap="wrap">
                                          {account.mobile && (
                                             <Flex alignItems="center" minW="fit-content">
                                                <Image src={phone} alt="Phone Icon" boxSize="20px" mr={2} />
                                                <Text fontSize="sm">{account.mobile}</Text>
                                             </Flex>
                                          )}

                                          {account.email && (
                                             <Flex alignItems="center" minW="fit-content">
                                                <Image src={Email} alt="Email Icon" boxSize="20px" mr={2} />
                                                <Text fontSize="sm">{account.email}</Text>
                                             </Flex>
                                          )}

                                          {account.panNo && (
                                             <Flex alignItems="center" minW="fit-content">
                                                <Image src={panno} alt="PAN Icon" boxSize="22px" mr={2} />
                                                <Text fontSize="sm">{account.panNo}</Text>
                                             </Flex>
                                          )}
                                       </Flex>

                                       {/* Second Row: Address */}
                                       {account.addressJson?.length > 0 && (
                                          <Flex alignItems="start" mb={4}>
                                             <Image src={map} alt="Address Icon" boxSize="20px" mr={2} mt={1} />
                                             <Box>
                                                {account.addressJson.map((address, index) => (
                                                   <Text key={index} fontSize="sm">
                                                      {address.address1}
                                                   </Text>
                                                ))}
                                             </Box>
                                          </Flex>
                                       )}

                                       {/* Third Row: GST, Broker, Balance */}
                                       <Flex gap={6} flexWrap="wrap">
                                          {account.gstRegNo && (
                                             <Flex alignItems="center" minW="fit-content">
                                                <Image src={gstno} alt="GST Icon" boxSize="20px" mr={2} />
                                                <Text fontSize="sm">{account.gstRegNo}</Text>
                                             </Flex>
                                          )}

                                          {account.brokername && (
                                             <Flex alignItems="center" minW="fit-content">
                                                <Image src={Brokername} alt="Broker Icon" boxSize="20px" mr={2} />
                                                <Text fontSize="sm">{account.brokername}</Text>
                                             </Flex>
                                          )}

                                          {account.amt ? (
                                             <GridItem display="flex" alignItems="center">
                                                <Image
                                                   src={Balance}
                                                   alt="editicon"
                                                   boxSize="20px"
                                                   mr={2}
                                                   title="Balance Icon"
                                                />
                                                {account.amt}
                                             </GridItem>
                                          ) : null}
                                       </Flex>
                                    </Box>
                                 ) : null}
                              </GridItem>

                              <GridItem w="100%">
                                 <InputField
                                    ref={transactionAtRef}
                                    type="date"
                                    name="transactionAt"
                                    label="Transaction Date"
                                    value={row.header.transactionAt}
                                    onChange={(e) => {
                                       let value = e.target.value; // yyyy-mm-dd
                                       const parts = value.split('-');
                                       if (parts[0]?.length > 4) {
                                          parts[0] = parts[0].slice(0, 4);
                                          value = parts.join('-');
                                       }
                                       handleInputChange('header', {
                                          target: {
                                             name: e.target.name,
                                             value,
                                          },
                                       });
                                    }}
                                    onKeyDown={(e) => handleKeyDown(e, accountRef, docNoRef)}
                                 />
                              </GridItem>

                              {/* 👉 Account field */}
                              <GridItem w="100%">
                                 <AccountSelect
                                    ref={accountRef}
                                    name="accountId"
                                    options={accountData}
                                    label="Account"
                                    value={row.header.accountId}
                                    errors={errors}
                                    errorName="header.accountId"
                                    isClearable
                                    isSearchable
                                    isDisabled={filedDisabled}
                                    onChange={(value) => {
                                       handleAccount('accountId', value);
                                    }}
                                    onKeyDown={(e) => handleKeyDown(e, brokerRef, transactionAtRef)}
                                    showCustomNoOptions={true}
                                    openfrom="salesdaybook"
                                    glGroup={targetGlGroup}
                                 />
                              </GridItem>

                              <GridItem w="100%">
                                 {renderDynamicDropdown(
                                    'brokerId',
                                    'Broker',
                                    accountData,
                                    {
                                       errorName: 'header.brokerId',
                                       value: row.header.brokerId,
                                       onChange: (value) => handleAccount('brokerId', value),
                                       focusBorderColor: 'blue.500',
                                       _focus: {
                                          boxShadow: '0 0 0 3px rgba(66, 153, 225, 0.6)',
                                       },
                                       ref: brokerRef,
                                       nextRef: supplierRef,
                                       preRef: accountRef,
                                       showCustomNoOptions: true,
                                       openfrom: 'account',
                                    },
                                    errors,
                                    textColor,
                                    false,
                                    'Select Broker',
                                 )}
                              </GridItem>

                              <GridItem w="100%">
                                 {renderDynamicDropdown(
                                    'representativeId',
                                    'Saleman',
                                    salesManList,
                                    {
                                       errorName: 'header.representativeId',
                                       value: row.header.representativeId,
                                       onChange: (value) => handleAccount('representativeId', value),
                                       focusBorderColor: 'blue.500',
                                       _focus: {
                                          boxShadow: '0 0 0 3px rgba(66, 153, 225, 0.6)',
                                       },
                                       ref: supplierRef,
                                       nextRef: itemRefs?.current[0],
                                       onKeyDown: (e) => {
                                          if (e.key === 'Enter' || e.key === 'Tab') {
                                             e.preventDefault();
                                             if (e.shiftKey) {
                                                brokerRef?.current?.focus();
                                             } else {
                                                if (companyData?.setting?.warehouseWishStock === true && herderview === true) {
                                                   wareHouseRef?.current?.focus();
                                                } else if (businessTypes?.businessType?.toUpperCase() === 'TEXTILE' && (daybook?.isMillIssue || daybook?.isOtherJobWork)) {
                                                   purchaseDocRef?.current?.focus();
                                                } else if (companyData?.setting?.warehouseWishStock === true && lineitemview === true && wareHouseRef?.current) {
                                                   wareHouseRef?.current?.focus();
                                                } else {
                                                   itemRefs?.current[0]?.focus();
                                                }
                                             }
                                          }
                                       },
                                       showCustomNoOptions: true,
                                       openfrom: 'Saleman',
                                    },
                                    errors,
                                    textColor,
                                    false,
                                    'Select Saleman',
                                 )}
                              </GridItem>


                              {companyData?.setting?.warehouseWishStock === true && herderview === true && (
                                 <GridItem className="seperator-width">
                                    {/* change */}
                                    {renderDynamicDropdown(
                                       'warehouseId',
                                       'Ware House',
                                       warehouseList,
                                       {
                                          value: row.header.warehouseId,
                                          onChange: (value) => handleAccount('warehouseId', value),
                                          showCustomNoOptions: true,
                                          openfrom: 'wareHouse',
                                          ref: wareHouseRef,
                                          onKeyDown: (e) => {
                                             if (e.key === 'Enter' || e.key === 'Tab') {
                                                e.preventDefault();
                                                if (e.shiftKey) {
                                                   supplierRef?.current?.focus();
                                                } else {
                                                   itemRefs?.current[0]?.focus();
                                                }
                                             }
                                          },
                                       },
                                       errors,
                                       textColor,
                                       false,
                                       'Select Ware House',
                                    )}
                                 </GridItem>
                              )}

                              {/* 👉 Purchase Document field for Textile   */}
                              {daybook && daybook?.isMillIssue && businessTypes?.businessType?.toUpperCase() === 'TEXTILE' ? (
                                 <GridItem w="100%">

                                    {dynamicDropdown(
                                       'purchaseDoc',
                                       'Purchase Document',
                                       purchase?.map((x) => ({
                                          label: `Inv Type: ${x.type}\n Bill NO: ${x.docNo}\n Item Name: ${x.itemName}\n ${x.accountName ? `( ${x.accountName} )` : ''}\n ${x.pendingQty1 ? `(Qty 1 :- ${x.pendingQty1})` : ''} ${x.pendingQty2 ? `(Qty 2 :- ${x.pendingQty2})` : ''} ${x.pendingQty3 ? `(Qty 3 :- ${x.pendingQty3})` : ''}`,
                                          id: x.id
                                       })),
                                       {
                                          errorName: 'header.purchaseDoc',
                                          value: purchaseDoc,
                                          onChange: (value) => {
                                             setPurchaseDoc(value);

                                             // if (value?.length === 0) {
                                             if (id) {
                                                setRow((prev) => {
                                                   const filtered = (prev.lineItem || [])
                                                      .filter((item) => ((item.pliId || item.pcliId) && item.id))
                                                      .map((item) => {
                                                         return {
                                                            ...item,
                                                            qty1: item.issueLineDetail?.length,
                                                            qty3: item.issueLineDetail?.reduce((acc, curr) => acc + curr.quantity3, 0) || 0,
                                                            takaDetails: item.issueLineDetail
                                                         }
                                                      });
                                                   return {
                                                      ...prev,
                                                      lineItem: filtered.length > 0 ? filtered : [initialLineItem],
                                                   }
                                                });
                                             } else {
                                                setRow((prev) => {
                                                   const filtered = (prev.lineItem || [])
                                                      .filter((item) => (!item.pliId && !item.pcliId) || item.id)
                                                      .map((item) => ({ ...item }));

                                                   return {
                                                      ...prev,
                                                      lineItem: filtered.length > 0 ? filtered : [initialLineItem],
                                                   }
                                                });
                                             }                                             // }

                                             if (row.header.accountId) {
                                             } else if (value?.length === 1) {
                                                // const findData = issueDocument.filter(
                                                //    (data) => data.issue_linedetail_id === value[0],
                                                // );
                                                // if (findData?.length > 0) {
                                                //    handleAccount('accountId', findData[0].accountId);
                                                //    accountRef.current.focus();
                                                // }
                                             }
                                          },
                                          focusBorderColor: 'blue.500',
                                          _focus: {
                                             boxShadow: '0 0 0 3px rgba(66, 153, 225, 0.6)',
                                          },
                                          ref: purchaseDocRef,
                                          nextRef: itemRefs?.current[0],
                                          onKeyDown: (e) => {
                                             if (e.key === 'Enter' || (e.key === 'Tab' && !e.shiftKey)) {
                                                e.preventDefault();
                                                itemRefs?.current[0]?.focus();
                                             }
                                          },
                                          showCustomNoOptions: true,
                                          openfrom: 'account',
                                       },
                                       errors,
                                       textColor,
                                       false,
                                       'Select Broker',
                                       true, // isSearchable
                                       undefined, // filteredOptions
                                       true, // isMulti
                                    )}
                                 </GridItem>
                              ) : null}
                           </Grid>

                           <Grid templateColumns="repeat(4, 1fr)" gap={6}>
                              <GridItem w="100%" colSpan={4}>
                                 <Box my={3}>
                                    <LineItem
                                       addLineItem={addLineItem}
                                       lineItems={row.lineItem}
                                       itemData={itemData}
                                       textColor={textColor}
                                       lastDaybook={daybook}
                                       removeLineItem={removeLineItem}
                                       handleOnChange={handleOnChange}
                                       companyData={companyList}
                                       totals={totals}
                                       handleStockModalOnClick={handleStockModalOnClick}
                                       handleStockModal={handleStockModal}
                                       errors={errors}
                                       refs={refs}
                                       prerefs={
                                          daybook && daybook?.isMillIssue && businessTypes?.businessType?.toUpperCase() === 'TEXTILE'
                                             ? purchaseDocRef
                                             : companyData?.setting?.warehouseWishStock === true && herderview === true
                                                ? wareHouseRef
                                                : supplierRef
                                       }
                                       setCurrentLineItemIdx={setCurrentLineItemIdx}
                                       warehouseList={warehouseList}
                                       lineitemview={lineitemview === true ? lineitemview : lineDetailview}
                                       selectcompany={companyData}
                                       billTermData={billTermData}
                                    />
                                 </Box>
                              </GridItem>
                           </Grid>

                           <Grid templateRows="repeat(1, 1fr)" templateColumns="repeat(4, 1fr)" gap={3}>
                              <GridItem w="100%" colSpan={2}>
                                 <Grid templateColumns="repeat(2, 1fr)" gap={3}>
                                    <GridItem w="100%">
                                       <InputField
                                          ref={dueDaysRef}
                                          type="number"
                                          name="dueDays"
                                          label="Due Days"
                                          value={row.header.dueDays}
                                          onChange={(e) => handleInputChange('header', e)}
                                          onKeyDown={(e) => {
                                             if (e.key === 'ArrowUp' || e.key === 'ArrowDown') {
                                                e.preventDefault();
                                             }
                                             if ((e.key === 'Tab' || e.key === 'Enter') && e.shiftKey) {
                                                if (billTermData.length > 0 && refs?.amountRefs?.current) {
                                                   const lastIndex = refs.amountRefs?.current?.length - 1;
                                                   refs.amountRefs.current[lastIndex]?.focus();
                                                } else {
                                                   const lastLineIndex = refs.rateRefs.current.length - 1;
                                                   refs.rateRefs.current[lastLineIndex]?.focus();
                                                }
                                             }
                                             handleKeyDown(e, dueDateRef);
                                          }}
                                          onWheel={(e) => e.target.blur()}
                                       />
                                    </GridItem>
                                    <GridItem w="100%">
                                       <InputField
                                          ref={dueDateRef}
                                          type="date"
                                          name="dueAt"
                                          label="Due Date"
                                          value={row.header.dueAt}
                                          onChange={(e) => handleInputChange('header', e)}
                                          onKeyDown={(e) => handleKeyDown(e, transportRef, dueDaysRef)}
                                       />
                                    </GridItem>

                                    <GridItem w="100%">
                                       {renderDynamicDropdown(
                                          'transportId',
                                          'Transport',
                                          transportList,
                                          {
                                             errorName: 'header.transportId',
                                             value: row.header.transportId,
                                             onChange: (value) => handleAccount('transportId', value),
                                             focusBorderColor: 'blue.500',
                                             _focus: {
                                                boxShadow: '0 0 0 3px rgba(66, 153, 225, 0.6)',
                                             },
                                             ref: transportRef,
                                             nextRef: vehicleRef,
                                             preRef: dueDateRef,
                                             showCustomNoOptions: true,
                                             openfrom: 'transport',
                                          },
                                          errors,
                                          textColor,
                                          false,
                                          'Select Transport',
                                       )}
                                    </GridItem>
                                    <GridItem w="100%">
                                       {renderDynamicDropdown(
                                          'vehicleId',
                                          'Vehicle',
                                          vehicleList,
                                          {
                                             errorName: 'header.vehicleId',
                                             value: row.header.vehicleId,
                                             onChange: (value) => handleAccount('vehicleId', value),
                                             focusBorderColor: 'blue.500',
                                             _focus: {
                                                boxShadow: '0 0 0 3px rgba(66, 153, 225, 0.6)',
                                             },
                                             ref: vehicleRef,
                                             nextRef: notesRef,
                                             showCustomNoOptions: true,
                                             openfrom: 'vehicle',
                                          },
                                          errors,
                                          textColor,
                                          false,
                                          'Select Vehicle',
                                       )}
                                    </GridItem>

                                    <GridItem w="100%" colSpan={2}>
                                       <TextareaField
                                          ref={notesRef}
                                          name="notes"
                                          label="Notes"
                                          value={row.header.notes}
                                          onChange={(e) => handleInputChange('header', e)}
                                          onKeyDown={(e) => {
                                             if (
                                                (e.key === 'Enter' && !e.shiftKey) ||
                                                (e.key === 'Tab' && !e.shiftKey)
                                             ) {
                                                e.preventDefault();
                                                if (submitRef.current) {
                                                   submitRef.current.focus();
                                                }
                                             }
                                          }}
                                       />
                                    </GridItem>

                                    <GridItem w="100%" colSpan={2}>
                                       {selectedStocks?.length > 0 ? (
                                          <TableContainer
                                             border="1px"
                                             borderColor="gray.200"
                                             borderRadius={5}
                                             maxH="300px"
                                             overflowY="auto">
                                             <Table variant="simple" size="sm">
                                                <Thead bg="gray.200">
                                                   <Tr>
                                                      <Th>Item</Th>
                                                      <Th>Series No</Th>
                                                      <Th>Warehouse</Th>
                                                      <Th>Action</Th>
                                                   </Tr>
                                                </Thead>
                                                <Tbody>
                                                   {selectedStocks &&
                                                      removeDuplicates(selectedStocks, 'serialNo')?.map(
                                                         (item, index) => {
                                                            return (
                                                               <Tr key={index}>
                                                                  <Td>{item.itemName}</Td>
                                                                  <Td>
                                                                     {item.serialNo}
                                                                     <Icon
                                                                        as={FaHistory}
                                                                        boxSize={4}
                                                                        ml={3}
                                                                        color="green.600"
                                                                        onClick={() => handleSerialHistory(item)}
                                                                        cursor="pointer"
                                                                     />
                                                                  </Td>
                                                                  <Td>{item.warehouseName}</Td>
                                                                  <Td>
                                                                     <IconButton
                                                                        colorScheme="red"
                                                                        size="sm"
                                                                        isDisabled={item.processStatus && item.processStatus === "PURCHASE"}
                                                                        onClick={() => removeStock(item)}
                                                                        icon={<FaTrash />}
                                                                     />
                                                                  </Td>
                                                               </Tr>
                                                            );
                                                         },
                                                      )}
                                                </Tbody>
                                             </Table>
                                          </TableContainer>
                                       ) : null}
                                    </GridItem>
                                 </Grid>
                              </GridItem>
                              <GridItem w="100%" colSpan={2} rowSpan={2}>
                                 <Grid templateRows="repeat(1, 1fr)" templateColumns="repeat(2, 1fr)" gap={3}>
                                    <GridItem colSpan={2}>
                                       <BillTerm
                                          textColor={textColor}
                                          billTermData={row.header.daybookId > 0 ? billTermData : []}
                                          billTerms={row.header.daybookId > 0 ? billTerms : []}
                                          netAmount={totals.netAmount}
                                          handleBillTermChange={handleBillTermChange}
                                          refs={refs}
                                       />
                                    </GridItem>
                                    <GridItem w="100%" colSpan={2}>
                                       <TaxableAmount
                                          totals={totals}
                                          isSameState={isSameState}
                                          finalNetAmount={finalNetAmount}
                                          daybook={filteredDaybooks.find((item) => item.id === row?.header?.daybookId)}
                                          company={company}
                                       />
                                    </GridItem>
                                 </Grid>
                              </GridItem>
                           </Grid>
                        </form>
                        <CardFooter justifyContent="flex-end" gap={3}>
                           {/* <Button colorScheme="blue" onClick={handleExchange} _focus={{}}>
                              Exchange
                           </Button> */}
                           <Button
                              ref={submitRef}
                              colorScheme="green"
                              fontSize="sm"
                              fontWeight="500"
                              borderRadius="full"
                              _active={{ bg: '#06b' }}
                              onClick={() => handleSubmit()}
                              isLoading={isLoading}
                              loadingText={id ? 'Updating...' : 'Saving...'}
                              disabled={isLoading}
                              _focus={{ outlineColor: 'blue.500 ' }}
                              onKeyDown={(e) => {
                                 if (e.key === 'ArrowRight') {
                                    e.preventDefault();
                                    closeRef.current?.focus();
                                 }
                              }}>
                              {id ? 'Update' : 'Save'}
                           </Button>
                           <Button
                              ref={closeRef}
                              colorScheme="red"
                              onClick={() => {
                                 dispatch(emptyIssueInventory());
                                 handleReset();
                                 navigate('/admin/inventory/issue');
                              }}
                              _focus={{ outlineColor: 'blue.500 ' }}
                              onKeyDown={(e) => {
                                 if (e.key === 'ArrowLeft') {
                                    e.preventDefault();
                                    submitRef.current?.focus();
                                 }
                              }}>
                              Cancel
                           </Button>
                        </CardFooter>
                     </>
                  )}
               </Box>
            </CardBody>
         </Card>

         {/* Serial number modal */}
         <SerialNumberModal
            isOpen={isOpenModal}
            onClose={onCloseModal}
            stockList={stockList}
            selectedStocks={selectedStocks}
            handleSelectStock={handleSelectStock}
            onCloseComplete={() => {
               setTimeout(() => {
                  if (daybook?.isAllowGstRate && company?.setting?.applyGST && daybook?.applyGst) {
                     gstRateRefs.current[currentLineItemIdx]?.focus();
                  } else {
                     rateRefs.current[currentLineItemIdx]?.focus();
                  }
               }, 0);
            }}
            currentItemId={row.lineItem[currentLineItemIdx]?.itemId}
            currentIdx={currentLineItemIdx}
            lineItem={row.lineItem}
         />

         {/* Customer Verify modal  */}
         <CustomerVerifyModal
            isOpen={isOpenVerifyModal}
            onClose={onCloseVerifyModal}
            accountId={row.header.accountId}
            entryData={salesInvoice}
            handleSubmit={handleSubmit}
            mobile={account?.mobile}
            isLoading={isLoading}
            entryType="issue"
         />

         <SelectTakaDetail
            isOpen={isOpenTakaDetailModal}
            onClose={onCloseTakaDetailModal}
            takaDetails={takaDetails}
            handleSaveTakaDetail={handleSaveTakaDetail}
            lineItem={row.lineItem}
            currentIdx={currentLineItemIdx}
            formType={id ? 'edit' : 'add'}
         />

         <TakaForm
            isOpen={isOpenTakaModal}
            onClose={onCloseTakaModal}
            handleTakaDetails={handleTakaDetails}
            currentTakaDetails={currentTakaDetails}
            onCloseComplete={() => {
               setTimeout(() => {
                  rateRefs.current[currentLineItemIdx]?.focus();
               }, 0);
            }}
         />

         <DeleteDialog
            isDeleteDialogOpen={isOpenDeleteModal}
            setDeleteDialogOpen={onCloseDeleteModal}
            handleDelete={handleDelete}
            title="Delete Line Item"
         />

         {/* Print Format Moal  */}
         <PrintFormat
            isOpen={isOpenPrintFormatModal}
            onClose={onClosePrintFormatModal}
            daybook={daybook}
            functionName="Sales Invoice"
            redirect="/admin/inventory/issue"
         />

         <Modal isOpen={isOpenSerialhistory} onClose={onCloseSerialhistory} size="6xl">
            <ModalOverlay />
            <ModalContent>
               <ModalHeader>Serial History({data[0]?.serial_no})</ModalHeader>
               <ModalCloseButton />
               <ModalBody>
                  {data.length > 0 ? (
                     <Table variant="simple" size="sm">
                        <Thead>
                           <Tr>
                              <Th>Doc No</Th>
                              <Th>Transaction at</Th>
                              <Th>Transaction Type</Th>
                              <Th>Account Name</Th>
                              <Th>Daybook Name</Th>
                              <Th>Item Rate</Th>
                           </Tr>
                        </Thead>
                        <Tbody>
                           {data.map((data, index) => (
                              <Tr key={index}>
                                 <Td>{data.doc_no}</Td>
                                 <Td>{new Date(data.transaction_at).toLocaleDateString('en-GB')}</Td>
                                 <Td>{data.transaction_type}</Td>
                                 <Td>{data.account_name}</Td>
                                 <Td>{data.daybook_name}</Td>
                                 <Td>{data.item_rate}</Td>
                              </Tr>
                           ))}
                        </Tbody>
                     </Table>
                  ) : (
                     <Text color="gray.500">No transaction history found.</Text>
                  )}
               </ModalBody>
            </ModalContent>
         </Modal>

         <Modal isOpen={isOpenAdjustedDocs} onClose={onCloseAdjustedDocs} size="6xl">
            <ModalOverlay />
            <ModalContent>
               <ModalHeader>Adjusted Docs</ModalHeader>
               <ModalCloseButton />
               <ModalBody>
                  {adjustedDocs?.length > 0 ? (
                     <Table variant="simple" size="sm">
                        <Thead>
                           <Tr>
                              <Th>Doc No</Th>
                              {/* <Th>Transaction at</Th> */}
                              {/* <Th>Transaction Type</Th> */}
                              <Th>Txn Date</Th>
                              <Th>Account Name</Th>
                              <Th>Daybook Name</Th>
                              <Th>Amount</Th>
                           </Tr>
                        </Thead>
                        <Tbody>
                           {adjustedDocs?.map((txn, index) => (
                              <Tr key={index}>
                                 <Td>{txn.adj_docno}</Td>
                                 {/* <Td>{new Date(txn.adj_txnDate).toLocaleDateString('en-GB')}</Td> */}
                                 {/* <Td>{txn.transaction_type}</Td> */}
                                 <Td>{new Date(txn.adj_txnDate).toLocaleDateString('en-GB')}</Td>
                                 <Td>{txn.adj_accountname}</Td>
                                 <Td>
                                    {selectedDaybookData?.length > 0
                                       ? txn.adj_daybookname === selectedDaybookData[0].name
                                          ? txn.daybookname
                                          : txn.adj_daybookname
                                       : txn.adj_daybookname}
                                 </Td>
                                 <Td>{txn.amount}</Td>
                              </Tr>
                           ))}
                        </Tbody>
                     </Table>
                  ) : (
                     <Text color="gray.500">No Adjusted Docs Data found.</Text>
                  )}
               </ModalBody>
            </ModalContent>
         </Modal>
      </>
   );
};

export default IssueForm;
